<template>
  <div class="scrollable phyExService" v-loading.fullscreen.lock="fullscreenLoading">
    <v-header></v-header>
    <div class="content">
      <div class="breadNav">
        <p v-if="phyPersonType=='staff'">
          健康管理 > 本人体检 > 填写预约信息
        </p>
        <p v-else> 健康管理 > 家属体检 > 填写预约信息</p>
      </div>
      <div class="tjUser" v-if="phyPersonType != 'dependents'">
        <p class="icon"></p>
        <p class="name">
          {{ $t("m.phyOrderList.titList.username") }}：{{ currentUser }}（{{
            allUserMsg.relationship_value
          }}）   
        </p>
        <p class="edit" @click="editBtn">编辑</p>
      </div>
      <!-- 家属 -->
      <div class="tjUser" v-if="phyPersonType == 'dependents'">
        <p class="icon"></p>
        <p class="name">{{ $t("m.medicalReports.phyPerson") }}：</p>
        <el-select :loading-text="$t('m.common.load')" :loading="peopleLoading" v-model="peoValue"
                   :placeholder="$t('m.dependentsMsg.changeDep')" @change="changeDep" class="depSelect"
                   style="width: 370px">
          <el-option v-for="(item, index) in relationship" :key="index" :label="item.name" :value="item.id" >
          </el-option>
        </el-select>
        <p class="edit" @click="addPhyShow" style="text-decoration: none !important">
          + {{ $t("m.dependentsMsg.addDepend") }}
        </p>
      </div>
      <!-- 城市 -->
      <div class="tjHos tjItem">
        <div class="tit">
          <p class="icon"></p>
          <p class="name">{{ $t("m.staffMsg.city") }}：</p>
          <el-select :loading-text="$t('m.common.load')" :loading="cityLoading" filterable v-model="cityValue"
                     :placeholder="$t('m.staffMsg.cityPlaceholder')" class="city" @change="changeCity">
            <el-option-group :key="$t('m.staffMsg.hotCity')" :label="$t('m.staffMsg.hotCity')">
              <el-option v-for="item in cityDataList.hot_areas" :key="item.code" :label="item.name" :value="item.id">
              </el-option>
            </el-option-group>
            <el-option-group v-for="group in cityDataList.area_group" :key="group.letter" :label="group.letter"
                             v-show="group.cities.length > 0">
              <el-option v-for="(item, index) in group.cities" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <!-- 机构分院 -->
      <div :class="
          (packageList != undefined && packageList.length > 0) ||
          (additionList != undefined && additionList.length > 0)
            ? 'tjHos tjItem tjSetMeal '
            : 'tjHos tjItem tjSetMeal'
        ">
        <div class="tit" style="border-bottom:none;">
          <p class="icon"></p>
          <p class="name">选择体检机构及分院：</p>
        </div>
        <div class="hospital" style="padding-bottom: 18px;">
          <p>体检机构及分院：</p>
          <div>
            <el-select style="width: 170px" :loading-text="$t('m.common.load')" :loading="brandLoading" :disabled="
                $route.query.type == 'staff'
                  ? cityId == ''
                  : cityId == '' || depId == ''
              " class="hosName" @change="changeBrands" v-model="organValue" :placeholder="$t('m.staffMsg.brands')">
              <el-option v-for="(item, index) in organList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>

            <el-select style="width: 568px !important" :loading-text="$t('m.common.load')" :loading="hospitalLoading"
                       v-model="hospitalValue" :placeholder="
                brandsCode == '' || cityValue == ''
                  ? $t('m.staffMsg.cityMeal')
                  : $t('m.staffMsg.hospital')
              " class="hosName" @change="changeHos" :disabled="brandsCode == '' || cityValue == ''"
                       :no-data-text="$t('m.common.nayHos')">
              <el-option v-for="(item, index) in hospitalList" :key="index" :label="item.name" :value="item.id"
                         style="width: 500px">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">
                  <!-- {{$t('m.staffMsg.distance')}}{{(item.distance*0.001) | number}}km  -->
                  <!-- <span>{{ $t("m.staffMsg.grade") }}</span> -->
                </span>
              </el-option>
            </el-select>
          </div>

        </div>
        <div class="hosDetail" v-if="hosId != ''">
          <!-- <div style="line-height: 20px;">
            <el-rate v-model="star" value="star" disabled style="margin-right: 5px;float: left; "></el-rate>
            {{ $t("m.staffMsg.grade") }}
            <span style="color: #FF000F;">{{ star }}</span>
          </div> -->
          <div style="color: #666;font-size: 16px;"> {{ addressMsg }}</div>
          <p style="width: 100px; text-align: left;margin-top:3px" @click="getHosMsg">
            {{ $t("m.phyOrderDetails.getHosDetail") }}
          </p>
        </div>
        <div style="margin-left:286px;padding-bottom:25px;color:#666;font-size:14px;font-weight:500">
            <span style="font-weight: bold;color: #ff000f;">温馨提示：</span><em class="hint">1.
                您在员工弹性福利平台兑换的自费加项包仅限于民营体检机构使用（其中汕头、大同、咸阳地区不适用），所有公立医院不适用</em><br><em class="hint"
                                                                          v-if="confirmMsg.cityNameCheck=='厦门市'||confirmMsg.cityNameCheck=='汕头市'||confirmMsg.cityNameCheck=='江门市'||confirmMsg.cityNameCheck=='中山市'||confirmMsg.cityNameCheck=='广州市'">2.
            同档位套餐公立医院比民营机构体检项目少；民营体检机构名额充足，服务环境良好，获取报告速度快，建议您优先选择民营体检机构进行体检。</em></div>

      </div>
      <!-- 套餐列表 -->
      <div v-if="
      phyDataList != undefined && phyDataList.length > 0
        " class="additionalItemPackage">
        <div class="tit" style="margin-top: 30px;">
          <p class="icon" style="float: left;"></p>
          <p class="name">选择体检套餐：</p>
        </div>
        <div class="msg" :style="phyDataList.length > 0?'paddingBottom:0':'paddingBottom:20px'">
          <div class="left1">
            <p>{{ $t("m.staffMsg.mealList") }}：</p>
          </div>
          <div style="margin-left: 20px; font-size: 16px; margin-top: 45px" v-if="comboLoading">
            <span>{{ $t("m.common.load") }}</span>
          </div>
          <div class="right" style="margin-top: 30px;margin-left: 25px;" v-else>
            <el-radio-group v-model="radio" @change="changePhy" style="width: 100%" v-if="hosId">
              <div class="tcName" :key="index" v-for="(item, index) in phyDataList" :data-id="item.id"
                   style="display: block;border:solid 1px #eaeaea; height: auto; padding: 15px 20px;width: 760px;">
                <div style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                      ">
                  <div>
                    <el-radio :label="item.id + '_'">{{ item.name }} {{ item.description }}<span
                      style="color:#FF000F;text-decoration:underline"
                      @click="getMealMsg(item.id)">{{ $t("m.phyOrderDetails.getMealDetail") }}</span>
                      <div v-if="item.marital == 1" style="padding-top: 14px;color: #666;font-size: 16px;">
                        *注：妇科检查仅适用于已婚或未婚有性生活史女性，且孕期不可做
                      </div>
                    </el-radio>
                  </div>
                  <div class="tcPrice" v-if="
                          $route.query.type == 'dependents' && free_amount === 0
                        ">
                    <p>
                      <em v-if="brandsSort == 1">{{ $t("m.common.total") }}：</em>
                      <!-- <em>￥</em> -->
                      {{
                        $route.query.free_times === "0"
                          ? "￥" + item.sell_price
                          : ""
                      }}
                    </p>
                  </div>
                </div>

                <!-- <p
                      v-if="item.gender===0"
                      style="font-size: 12px;margin-top: 10px;color: #666;"
                    >{{$t('m.staffMsg.exe')}}</p> -->
              </div>
            </el-radio-group>
            <div class="tcName1" v-else>
              <p style="font-size: 16px; line-height: 16px; color: #999 ;">
                {{ $t("m.staffMsg.firstHos") }}
              </p>
            </div>
          </div>
        </div>
        <!-- <p v-if="phyGender === 0" style="
        font-size: 12px;
        margin-left: 320px;
        color: #666;
        margin-bottom: 30px;
      ">
      {{ $t("m.staffMsg.exe") }}
    </p> -->
        <!-- 定制加项 -->
  <!--   二选一     -->
  
  <div v-if="$route.query.type=='staff'">
    <div class="tcts" v-if="allUserMsg.gender_value =='女'">
    当前套餐根据您的婚姻状况显示，如您需要切换有/无妇科检查套餐，请在个人中心重新编辑您的婚姻状况
  </div>
  </div>
  <div v-else>
    <div class="tcts" v-if="gender_value =='女'">
    当前套餐根据您的婚姻状况显示，如您需要切换有/无妇科检查套餐，请在个人中心重新编辑您的婚姻状况
  </div>
  </div>
        <div class="msg" style="margin-top: 17px;" v-if="packageList != undefined && packageList.length > 0">
          <div class="left">
            <p>腰颈椎2选1：</p>
          </div>
          <div style="margin-left: 20px; font-size: 16px; margin-top: 15px" v-if="packagesLoading">
            <span>{{ $t("m.common.load") }}</span>
          </div>
          <div class="right" style="margin-top: 30px" v-else>
            <el-checkbox-group v-model="packageCheckList" @change="changePackage">
              <div class="packageItem" :key="index" v-for="(item, index) in packageList">
                <div class="name">
                  <el-checkbox :disabled="item.disabled" :label="item.id">{{
                      item.name
                    }}
                  </el-checkbox>
                </div>
                <div style="margin-left: 26px">
                  <div class="msgItem" :key="indexPro" v-for="(itemPro, indexPro) in item.items"
                       style="display: inline-block; margin-left: 0px">
                    <p style="display: flex; align-items: center">
                      <span v-if="indexPro != 0" style="padding: 0 5px">+</span>
                      {{ itemPro.name }}
                      <img style="display: inline-block" src="../../../assets/detail.png" @click="
                            packageDetail(itemPro.name, itemPro.clinic_mean)
                          "/>
                    </p>
                  </div>
                </div>
                <!-- <div class="per">
                  <p>{{$t('m.staffMsg.forPeople')}}：</p>
                  <p>{{item.applicable_people}}</p>
                </div>-->
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <!-- 自费加项 -->
      <div class="zfMsg tjHos tjItem additionalItemPackage" v-if="
         additionList!='' && additionList!=undefined"
           style="padding-top: 30px">
        <div class="tit" style="margin-top: 30px;">
          <p class="icon" style="float: left;"></p>
          <p class="name">选择体检加项：</p>
        </div>
        <!--   自费加项     -->
        <div v-if="additionList != undefined && additionList.length > 0">
          <div class="left1" style="margin-top: 25px !important;margin-right: 23px;">
            <p>自费加项：</p>
          </div>
          <div style="margin-left: 20px; font-size: 16px; margin-top: 15px" v-if="additionLoading">
            <span>{{ $t("m.common.load") }}</span>
          </div>

          <div class="right" style="
            margin-left: 20px;
            display: flex;
            width: 760px;
            flex-flow: wrap;
            margin-top: 30px;
          " v-else>
            <div v-if="$route.query.type == 'staff'" style="
              padding-left: 20px;
              display: flex;
              align-items: center;
              text-align: justify;
              width: 760px;
              padding: 16px 20px;
              background: #FFEEEF;
              border: 1px solid rgba(234, 234, 234, 1);
            ">
              <p style="font-size: 18px; line-height: 26px; color:#FF000F" v-if="self_paid_packages_total_count!=0">
                您已通过公司弹性福利平台兑换了 {{ self_paid_packages_total_count }} 个自费加项包
              </p>
              <p style="font-size: 18px; line-height: 26px; color:#FF000F" v-else>为您推荐以下加项项目，享企业折扣</p>
            </div>
            <div v-if="$route.query.type == 'dependents'" style="
              padding-left: 20px;
              display: flex;
              align-items: center;
              text-align: justify;
              width: 760px;
              padding: 16px 20px;
              background: #FFEEEF;
              border: 1px solid rgba(234, 234, 234, 1);
            ">
              <p style="font-size: 18px; line-height: 26px; color:#FF000F">
                为您推荐以下加项项目，享企业折扣
              </p>
            </div>
            <div class="addition" :key="index" v-for="(item, index) in additionList"
                 style="margin-top: 0; min-width: 50%; max-width: 50%; width: 50%">
              <el-checkbox-group v-model="additionCheckList" @change="changeAddition"
                                 style="margin-left: 0; width: 100%">
                <div class="additionItem" style="
                    border-bottom: none;
                    padding-bottom: 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                  ">
                  <div style="display: flex; align-items: flex-end;font-weight: bold;">
                    <el-checkbox :checked="item.checked" :disabled="item.flag" :label="item.id" @change="aaaaaaa($event, item)"
                                 style="font-weight: bold;color: #333;font-size: 18px;">{{ item.name }}
                    </el-checkbox>
                    <!-- <img style="margin-left:10px;" src="../../../assets/tuijian_addition.svg" alt=""> -->
                    <img style="margin-left: 10px" v-if="item.isRecommend" src="../../../assets/tuijian_addition.svg"
                         alt=""/>
                  </div>
                  <p style="
                      font-size: 16px;
                      line-height: 16px;
                      color: #FF000F;
                      font-weight: bold;
                      margin-top: 0;
                    ">
                    {{ item.use_rights ? "可使用" : "¥" + item.sell_price }}
                  </p>
                  <!-- <p v-if="item.description!=''" style="margin-top: 10px;">{{item.description}}</p> -->
                </div>
              </el-checkbox-group>
              <div class="syrq" v-if="item.applicable_people">
                <div>
                  <img src="../../../assets/适用人群.png" alt="" style="float: left;">
                  <span>适用人群</span>
                  <p style="font-size: 15px;font-weight: 400;">{{ item.applicable_people }}</p>
                </div>

              </div>
              <div class="syrq" v-if="item.medical_advice" style="margin-top: 15px;">
                <div>
                  <img src="../../../assets/医学建议.png" alt="" style="float: left;">
                  <span>医学建议</span>
                  <p style="font-size: 15px;font-weight: 400;">{{ item.medical_advice }}</p>
                </div>

              </div>
              <div style="margin-left: 25px; margin-right: 15px" class="jctype">
                <div class="msg" :key="indexAdd" v-for="(itemAdd, indexAdd) in item.items" style="
                  margin-top: 10px;
                  display: inline-block;
                  width: auto;
                ">

                  <div class="msgLeft">
                    <span style="width: 6px;height: 6px;background: #FF000F;margin-right: 10px;"></span>
                    <span style="font-size: 14px; color: #666; line-height: 14px">{{
                        itemAdd.name
                      }}</span>

                    <!-- <el-checkbox :label="itemAdd.name" @change="changeAlone($event,item.name)">{{itemAdd.name}}</el-checkbox> -->
                    <img src="../../../assets/detail.png" style="margin: 0 5px; cursor: pointer"
                         @click="packageDetail(itemAdd.name, itemAdd.clinic_mean)"/>
                  </div>
                  <!-- <p class="price">{{$t('m.staffMsg.exclusivePrice')}}：￥{{itemAdd.sell_price}}</p> -->
                </div>
                <!-- <div class="per" style="margin-left: 0;">
                  <p>{{$t('m.staffMsg.forPeople')}}：</p>
                  <p>{{item.applicable_people}}</p>
                </div>-->
              </div>
            </div>


            
          </div>
          <div
            style="padding: 15px 0 0 0;margin: 0 auto;margin-left: 296px;color: #666;font-size: 14px;line-height: 25px;">
          <span
            style="font-weight: bold;font-size: 14px;">购买须知：</span>若体检时自费加项项目未做，请于当日内在体检中心前台联系乐荐办理加项包退费，延期/放弃则无法退<br>费，敬请理解！
          </div>
        </div>

      </div>
      <!-- 选择时间 -->
      <div class="time tjUser">
        <i class="icon"></i>
        <p class="name">选择体检时间：</p>
        <div style="margin-left: 20px; font-size: 16px" v-if="timeLoading">
          <span>{{ $t("m.common.load") }}</span>
        </div>
        <el-date-picker v-else style="width: 760px !important; font-weight:600;font-size: 18px;" v-model="tjTimeValue"
                        type="date" @change="getTime"
                        format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="
              hosId == '' ? $t('m.staffMsg.firstHos') : phyId == ''?'请先选择套餐':$t('m.staffMsg.time')
            " class="chooseTime" :picker-options="pickerOptions"
                        :disabled="hosId == '' ||phyId == '' "></el-date-picker>
        <!-- <div v-if="!timeLoading" style="
            font-size: 14px;
            color: #666;
            margin-left: 20px;
          ">
          {{ $t("m.staffMsg.temporalCue") }}
        </div> -->
      </div>

      <!-- 是否展示体检报告 -->
      <div
        class="reportTit"
        v-if="
        $route.query.type === 'dependents'
      "
      >
        <div>
          <p class="icon" style="float: left;"></p>
          <p class="name">尊敬的客户，您好！</p>
        </div>
        <p class="xq">
          因体检报告为个人隐私，本平台暂无法提供家属体检报告查询功能。
        </p>
        <p class="xq">
          您可在体检结束后，关注该体检机构发送的体检报告出具通知，按操作获取并查看，感谢您的理解与支持！
        </p>
      </div>
      <div class="tjUser2" v-if="phyPersonType === 'staff' && reportType === 0 && branchType===0">
        <div class="name2">
          <p class="icon2"></p>
          <div style="float: left;">
            请查看并阅读 <a style="text-decoration: underline;color:#FF000F; " target="1"
                      href="../../../../static/pdf/用户授权协议.pdf">《体检报告授权协议》</a>,确认是否同意在本平台查看体检报告。
          </div>
          <div style="float: left;">
            <el-radio-group v-model="isCreateUser" @change="agreement">
              <el-radio :label="item.value" :key="item.value" v-for="(item,index) in isCreateNewUser"
                        style="float: left;">{{ item.label }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="hint2" v-if="brandsCode==1602 || isCreateUser==0"><span style="color:#FF000F">*提示：</span>
          <p>
            <em v-if="brandsCode==1602&&isCreateUser==1">在本平台同意授权查看体检报告，体检后仍需要在该分院填写授权书，同时授权才可在本平台在线查看体检报告；<br></em>
            <em v-if="isCreateUser==0">您当前未授权则不能在本平台查询报告，并无法享受报告解读服务；<br>(如选择同意授权，体检报告数据将严格保密，不会产生个人信息泄漏)</em>
          </p></div>
        <!-- <div v-if="isCreateUser==0" style="font-size: 16px;" :style="isCreateUser==0?'padding:30px 0 30px 0':'padding:30px 0 0 30px'"><span style="color:#FF000F">*提示：</span>您当前未授权则不能在本平台查询报告，并无法享受报告解读服务；<br/><span style="padding-left:42px ;">（如选择同意授权，体检报告数据将严格保密，不会产生个人信息暴露）</span></div> -->
      </div>

      <div class="tjUser"
           v-else-if="phyPersonType === 'staff' && (reportType!=0||(reportType==0 && branchType==1))">
        <p class="icon"></p>
        <p class="name">
          该分院不支持在本平台查看体检报告，报告获取方式请在体检结束后向前台咨询
        </p>
      </div>

      <div class="integralMsg" v-if="openTxt == '收起详情>>' && limitMsg.payment_detail.exam_package.name!=''" id="priceMsg">
        <div class="combo">
          <p>{{ limitMsg.payment_detail.exam_package.name }}</p>
          <p style="color:#FF000F;">¥{{ limitMsg.payment_detail.exam_package.price }}</p>
        </div>
        <div v-if="limitMsg.payment_detail.extra_packages.length>0 && limitMsg.payment_detail.extra_packages!=''">
          <h3 style="color:#FF000F;">
            腰颈椎2选1
          </h3>
          <div class="combo" style="padding:0 30px 0 30px;" v-for="item in limitMsg.payment_detail.extra_packages">
            <p>{{ item.name }}</p>
            <p style="color:#FF000F;">¥{{ item.price }}</p>             
          </div>
        </div>
        <div v-if="limitMsg.payment_detail.self_paid_packages.length>0">
          <h3 style="color:#FF000F;">
            自费加项
          </h3>
          <div class="combo" style="padding:0 30px 0 30px;" v-for="item in limitMsg.payment_detail.self_paid_packages">
            <p>{{ item.name }}</p>
            <p style="color:#FF000F;">¥{{ item.price }}</p>
          </div>
        </div>
        <!-- <h3 v-if="limitMsg.payment_detail.self_paid_packages.length">
         定制加项
        </h3>
        <div
          class="list"
          v-if="limitMsg.extra_packages!=''"
        >
          <div>
            <div
              class="item"
              v-for="(item, index) in limitMsg.payment_detail
                .self_paid_packages"
              :key="index"
            >
              <p>{{ item.name }}</p>
              <p>¥{{ item.price }}</p>
            </div>
          </div>
        </div> -->
        <!-- <div class="jf">
          <p>{{$t('m.writeSubscribe.msg3') }}</p>
          <p>¥{{ limitMsg.sett_price }}</p>
        </div>
        <div class="jf" v-if="$route.query.type === 'staff' && brandsSort == 0">
          <p>{{$t('m.writeSubscribe.msg31') }}</p>
          <p>- ¥{{ limitMsg.real_received }}</p>
        </div>
        <div class="jf" v-if="$route.query.type === 'staff' && brandsSort == 0">
          <p>{{$t('m.writeSubscribe.msg32') }}</p>
          <p>{{ limitMsg.credit_amount }}</p>
        </div> -->
      </div>
      <div class="integral" :style="openTxt=='收起详情>>'?'marginTop:0px':'marginTop:20px'">
        <div class="left" v-if="limitMsg">
          <p><span @click="zhankai" style="margin-left: 10px;cursor: pointer; color: #FF000F;">{{
              openTxt
            }}</span></p>
        </div>
        <div class="right">
          <!-- <p class="jxNum">已选择<span>1</span>件加项包</p> -->
          <p class="price">
            价格总计：
            <span>￥{{ showLimit }}</span>
          </p>
          <p class="submit" @click="submit">{{ $t("m.common.submit") }}</p>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
    <!-- 城市弹框 -->
    <el-dialog title="提示" :visible.sync="dialogVisible2" width="30%">
      <span v-html="cityTitle"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible2 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看分院详情弹窗 -->
    <div id="interpret">
      <el-dialog :visible.sync="interpretVisible" :close-on-click-modal="false">
        <div v-if="hosDetailLoading" style="width: 100%; display: flex; justify-content: center">
          <p style="font-size: 16px; color: #333">{{ $t("m.common.load") }}</p>
        </div>
        <div v-if="!hosDetailLoading" class="interpretMsg">
          <div class="hospitalName">
            <p class="icon"></p>
            <p class="name"></p>
              {{ $t("m.staffHosDetail.hos") }}：{{ datajson.name }}
            </p>
          </div>
          <div class="map" id="XSDFXPage"></div>
          <div class="mapMsg">
            <p>
              <span>{{ $t("m.staffHosDetail.address") }} :</span>
              <span>{{ datajson.address }}</span>
            </p>
            <p>
              <span>{{ $t("m.staffHosDetail.time") }} :</span>
              <span>{{ datajson.work_time }}</span>
            </p>
            <!-- <p><span>{{$t('m.staffHosDetail.phone')}} : </span><span>{{datajson.inst_contact}} </span></p> -->
            <!-- <p>
              <span>{{$t('m.staffHosDetail.msg')}} :</span>
              <span>{{datajson.description}}</span>
            </p>
            <p>
              <span>{{$t('m.staffHosDetail.line')}} :</span>
              <span>{{datajson.traffic_route}}</span>
            </p> -->
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeBtn('hos')">{{
              $t("m.common.closeBtn")
            }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 查看套餐详情 -->
    <div id="interpret">
      <el-dialog :visible.sync="combointerpretVisible" :close-on-click-modal="false">
        <div v-if="comboDetailLoading" style="width: 100%; display: flex; justify-content: center">
          <p style="font-size: 16px; color: #333">{{ $t("m.common.load") }}</p>
        </div>
        <div v-if="!comboDetailLoading" class="interpretMsg">
          <div class="mealName">
            <p class="icon"></p>
            <p class="name">
              {{ $t("m.staffMsg.mealList") }}：{{ datajson.name }}
              {{ datajson.description }}
            </p>
            <p class="msg">
              {{
                $t("m.staffMealDetail.mealNum1")
              }}{{
                datajson.check_item_count
              }}{{
                $t("m.staffMealDetail.mealNum2")
              }}{{ $t("m.staffMealDetail.mealNum3") }}
            </p>
          </div>
          <p style="
              font-size: 14px;
              line-height: 26px;
              margin-top: 20px;
              color: #FF000F;
            ">
            温馨提示：由于各体检中心/医院设备及检验方式不同，体检套餐中个别项目会略有调整，具体请以体检中心/医院为准。
          </p>
          <div class="details" :key="index" v-for="(item, index) in datajson.items">
            <div class="tit">
              <p>{{ item.name }}</p>
            </div>
            <el-table :data="item.items" border stripe style="width: 100%">
              <el-table-column prop="name" :label="$t('m.staffMealDetail.medicalItems')">
              </el-table-column>
              <el-table-column prop="clinic_mean" :label="$t('m.staffMealDetail.examinationSignificance')">
              </el-table-column>
              <el-table-column prop="content" :label="$t('m.staffMealDetail.checkItems')">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeBtn('combo')">{{
              $t("m.common.closeBtn")
            }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 选择加项包的数量低于免费的数量的弹窗 -->
    <el-dialog :visible.sync="numVisible" :close-on-click-modal="false">
      <div class="reportMsg">
        <p style="font-size: 20px; color: #333">
          {{ $t("m.staffMsg.isNoChoose") }} {{ max_extraexampackages }}
          {{ $t("m.staffMsg.noChooseNum") }}？
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="numVisible = false">{{
            $t("m.common.cancelBtn")
          }}</el-button>
        <el-button type="primary" @click="numOk">{{
            $t("m.common.define")
          }}</el-button>
      </span>
    </el-dialog>
    <!-- 选择深圳温馨提示 -->
    <el-dialog :visible.sync="reminder" :close-on-click-modal="false">
        <div class="reportMsg">
          <p style="font-size:22px;margin-bottom: 10px;font: bold;">温馨提示：</p>
          <p style="font-size: 16px; color: #333; text-indent: 2em;line-height:25px;">
              {{cityId=='141'?'根据深圳市卫健委要求，因受疫情影响，即日起深圳地区所有分院均需持三日内核酸检测阴性结果方能进行体检，造成不便，还望理解。':cityId=='163'?'由于疫情影响，乌鲁木齐所有体检门店的客人需提供7日之内的有效核酸检测报告方可体检，给您带来的不便敬请谅解':''}}
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="reminder=false">{{
                      $t("m.common.define")
                      }}</el-button>
        </span>
      </el-dialog>
        <!-- ct加项包提示 -->
       <el-dialog :visible.sync="ctPackage" :close-on-click-modal="false">
        <div class="reportMsg">
          <p style="font-size:22px;margin-bottom: 10px;font: bold;">温馨提示：</p>
          <p style="font-size: 16px; color: #333; text-indent: 2em;line-height:25px;">
            胸部CT”为“X光胸部正位”的升级检查项目，为了您的身体健康，同一部位不能重复放射性检查。故如您选择购买此加项包，则请您放弃套餐中的”胸部正位”项目（“胸部CT”价格为“X光胸部正位”的升级后差额价格），感谢您的理解！
          </p>
        </div>
        <span slot="footer" class="dialog-footer">

          <el-button type="primary" @click="ctPackage=false">{{
                      $t("m.common.define")
                      }}</el-button>
        </span>
      </el-dialog>

    <!-- 添加家属 -->
    <el-dialog :title="$t('m.person.addPhy')" :visible.sync="addPhysicalVisible"
               :close-on-click-modal="closeOnClickModal">
      <div class="editMsg">
        <div class="name item">
          <p>{{ $t("m.staffMsg.editDialog.name") }}</p>
          <input type="text" maxlength="30" name :placeholder="$t('m.staffMsg.editDialog.inputName')"
                 ref="addPhyName"/>
        </div>
        <div class="cardType item">
          <p>{{ $t("m.staffMsg.editDialog.cardType") }}</p>
          <div class="radioDiv">
            <el-dropdown trigger="click" style="cursor: pointer" @command="handleCommand">
              <span :class="
                  idcardType == $t('m.staffMsg.editDialog.chooseType')
                    ? 'el-dropdown-link'
                    : 'el-dropdown-link active'
                " style="width: 60%; color: #999">
                {{ idcardType }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">{{
                    $t("m.common.nationalType.idcard")
                  }}
                </el-dropdown-item>
                <el-dropdown-item command="b">{{
                    $t("m.common.nationalType.passport")
                  }}
                </el-dropdown-item>
                <el-dropdown-item command="c">{{
                    $t("m.common.nationalType.gat")
                  }}
                </el-dropdown-item>
                <el-dropdown-item command="d">{{
                    $t("m.common.nationalType.other")
                  }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="idcard item">
          <p>{{ $t("m.staffMsg.editDialog.card") }}</p>
          <input type="text" maxlength="50" onkeyup="value=value.replace(/[\W]/g,'')" name :placeholder="
              idcardType === '' || idcardType != '身份证'
                ? '请输入证件号'
                : '请输入证件号,X为大写'
            " ref="addPhyidCard"/>
        </div>
        
        <div class="sex item">
          <p>{{ $t("m.staffMsg.editDialog.sex") }}</p>
          <div class="radioDiv">
            <el-radio v-model="sexRadio" label="1">{{
                $t("m.common.man")
              }}
            </el-radio>
            <el-radio v-model="sexRadio" label="2">{{
                $t("m.common.woman")
              }}
            </el-radio>
          </div>
        </div>
        <div
        class="mobile item"
        label="婚姻状况"
        prop="jsmarriage"
      >
        <p>婚姻状况</p>
        <el-radio-group v-model="jsmarriage">
          <el-radio :label="0">未婚</el-radio>
          <el-radio :label="1">已婚</el-radio>
        </el-radio-group>
      </div>
      <div v-if="sexRadio==2 && jsmarriage!=null" class="ts">
        *婚否信息会影响对应的套餐内容：选择“未婚”，则对应“无妇科检查”套餐，如需要妇科检查，请您选择“已婚”
          （妇科检查仅适用于已婚或未婚有性生活史女性，且孕期不可做）
      </div>
        <div class="sex item" v-if="isIdCard">
          <p>{{ $t("m.staffMsg.editDialog.birthday") }}</p>
          <div class="radioDiv" id="birthDate" style="padding-left: 10px !important">
            <el-date-picker v-model="birthDate" type="date" default-value="1990-01-01"
                            :placeholder="$t('m.staffMsg.editDialog.chooseTime')"></el-date-picker>
          </div>
        </div>
        <div class="idcard item">
          <p>{{ $t("m.staffMsg.editDialog.phone") }}</p>
          <input type="text" oninput="value=value.replace(/[^\d]/g,'')" name
                 :placeholder="$t('m.staffMsg.editDialog.inputPhone')" ref="addPhyphone"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addPhysicalVisible = false">{{
            $t("m.common.cancelBtn")
          }}</el-button>
        <el-button type="primary" :loading="dialogLoading" @click="addPhyOkBtn">{{ $t("m.common.define") }}
        </el-button>
      </span>
    </el-dialog>
<!-- 编辑体检人 -->
    <el-dialog
    :title="$t('m.staffMsg.editDialog.tit')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="closeOnClickModal"
  >
    <div class="editMsg">
      <div class="name item">
        <p>{{ $t('m.staffMsg.editDialog.name') }}</p>
        <p>{{ allUserMsg.name }}</p>
      </div>
      <div class="sex item">
        <p>{{ $t('m.staffMsg.editDialog.sex') }}</p>
        <p>{{ allUserMsg.gender_value }}</p>
      </div>
     
      <div class="cardType item">
        <p>{{ $t('m.staffMsg.editDialog.cardType') }}</p>
        <p>
          {{ allUserMsg.identity_type == 1 ? $t('m.common.nationalType.idcard') : (allUserMsg.identity_type == 2 ? $t('m.common.nationalType.passport') : (allUserMsg.identity_type == 3 ? $t('m.common.nationalType.gat') : $t('m.common.nationalType.other'))) }}</p>
      </div>
      <div class="idcard item">
        <p>{{ $t('m.staffMsg.editDialog.card') }}</p>
        <p>{{ allUserMsg.identity_code }}</p>
      </div>
      <div
        class="mobile item"
        label="婚姻状况"
        prop="allUserMsg.marriage"
      >
        <p>婚姻状况</p>
        <el-radio-group v-model="allUserMsg.marriage">
          <el-radio :label="0">未婚</el-radio>
          <el-radio :label="1">已婚</el-radio>
        </el-radio-group>
      </div>
      <div v-if="allUserMsg.gender_value=='女'" class="ts">
       *婚否信息会影响对应的套餐内容：选择“未婚”，则对应“无妇科检查”套餐，如需要妇科检查，请您选择“已婚” （妇科检查仅适用于已婚或未婚有性生活史女性，且孕期不可做）
      </div>
      <div class="mobile item">
        <p>{{ $t('m.staffMsg.editDialog.phone') }}</p>
        <input
          type="text"
          name
          :placeholder="$t('m.staffMsg.editDialog.inputPhone')"
          v-model="allUserMsg.contacttel"
          ref="getphone"
        />
      </div>
      <div v-if="yzm">
        <div
        class="mobile item"
        style="width: 70%;position: relative;"
      >
        <p>验证码</p>
        <input
          type="text"
          name
          placeholder="请输入验证码"
          v-model="code"
        />
      </div>
   
    <div class="djs"v-if="phomeCodeShow" @click="getCode()">发送验证码 </div>
    <div class="djs1" v-else>{{ counts }}</div>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="dialogVisible =false">{{ $t('m.common.cancelBtn') }}</el-button>
      <el-button
        type="primary"
        :loading="dialogLoading"
        @click="editOkBtn"
      >{{ $t('m.common.define') }}</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import header from "../../common/header.vue";
import footer from "../../common/footer.vue";
import getCurrentCityName from "../../../../static/js/getUserLocation.js";

var timeData = [];
let phoneReg = /^1[3456789]\d{9}$/,
  cardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
export default {
  name: "phyExService",
  data() {
    return {
      timeData: [],
      pickerOptions: {
        disabledDate(time) {
          var year = time.getFullYear(),
            month = ("0" + (time.getMonth() + 1)).slice(-2),
            date = ("0" + time.getDate()).slice(-2);
          var dateStr = year + "-" + month + "-" + date;
          return timeData.indexOf(dateStr) == -1;
        },
      },
      dialogLoading: false,
      dialogVisible2: false,
      cityTitle: "",
      settings: "",
      radio: "",
      cityValue: "",
      cityId: "", //选中的城市id
      hospitalValue: "",
      tjTimeValue: "", //选中的预约时间
      phyDataList: [],
      adcode: "",
      cityDataList: [],
      packageList: [],
      packageCheckList: [],
      additionCheckList: [],
      additionList: [],
      lat: "",
      lng: "",
      phyId: "", //选中的套餐的id
      hospitalList: [],
      hosId: "", //选中的分院的id
      addressMsg: "",
      isFirstEnter: false, // 定义变量来判断是否第一次进入，默认false
      project: {},
      isAloneMsg: false,
      showLimit: 0.0, //实时展示的额度
      phyPrice: "",
      equityCard: 0, //选中的权益卡的id
      packagesIDS: [], //选中加项包的id数组
      packagesCode: [], //选中加项包的id、code数组
      additionIDS: [], //选中加项的id数组
      additionCode: [], //选中加项的id、code数组
      timeCheck: "", //转化格式后的时间
      confirmMsg: {}, //转入确认订单页面的文字展示集合
      //编辑体检人的一些字段
      dialogVisible: false,
      isMobile: true,
      show: false,
      counts: "",
      timer: null,
      mobileVal: "",
      organList: [], //医院分类
      organValue: "",
      brandsCode: "",
      brandsSort: "", //区分是私立医院还是公立医院
      star: 0,
      peoValue: "",
      depId: "",
      addPhysicalVisible: false,
      relationRadio: "1",
      isIdCard: false,
      idcardType: this.$t("m.staffMsg.editDialog.chooseType"),
      marryRadio: "1",
      closeOnClickModal: false,
      sexRadio: "0",
      birthDate: "",
      phyPersonType: "", //是家属还是员工体检
      interpretVisible: false, //分院弹窗是否显示
      datajson: {},
      combointerpretVisible: false, //套餐详情弹窗是否显示
      reportVisible: false, //授权报告弹窗是否显示
      isAgree: 0,
      max_extraexampackages: 0,
      minimum_extra_packages: 0,
      numVisible: false,
      provinceArr: [],
      cityArr: [],
      countyArr: [],
      areaArr: [],
      consigneeJSON: {
        consigneeName: "",
        consigneePhone: "",
        consigneeAddress: "",
        consigneeProvince: "",
        consigneeCity: "",
        consigneeCounty: "",
        consigneeArea: "",
        consigneeProvinceName: "",
        consigneeCityName: "",
        consigneeCountyName: "",
        consigneeAreaName: "",
      },
      allUserMsg: {},
      phyExPeoList: [],
      cityLoading: false,
      peopleLoading: false,
      brandLoading: false,
      hospitalLoading: false,
      fullscreenLoading: false,
      ConsigneeProvinceLoading: false,
      ConsigneeCityLoading: false,
      ConsigneeCountyLoading: false,
      ConsigneeAreaLoading: false,
      timeLoading: false,
      comboLoading: false,
      packagesLoading: false,
      additionLoading: false,
      hosDetailLoading: false,
      comboDetailLoading: false,
      free_amount: 0,
      reportRadio: 1,
      isReport: false,
      peoType: "",
      isShowReport: false,
      dhNum: 0,
      phyGender: "",
      hospitalId: "", //机构分院id，
      phyID: null,
      isCreateNewUser: [
        {
          label: "同意",
          value: 1,
        },
        {
          label: "不同意",
          value: 0,
        },
      ],
      isCreateUser: 1,
      agreementId: null,
      institutionType: null,
      xtypex: "",
      reminder: false, //选择机构温馨提示
      limitMsg: [], //价格详情
      openTxt: "展开详情>>",
      number: 0,
      self_paid_packages_total_count: 0,
      self_paid_packages: [],
      reportType: null, //判断分院是否授权
      branchType: null, //区分慈铭
      code: null,
      phomeCodeShow: true,
      ctPackage: false, //ct加项包提示框
      yzm: false,
      jsmarriage: null,
      gender_value: "",
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer,
  },
  created() {
    this.settings =JSON.parse(sessionStorage.getItem("settings")) 
    let _this = this;
    _this.isFirstEnter = true;
    _this.project = JSON.parse(sessionStorage.getItem("project"));
    _this.self_paid_packages = sessionStorage.getItem("self_paid_packages");
    _this.showLimit = 0.0;
    _this.limitMsg = [];
    _this.number = 0;
    _this.counts = 0;
    _this.self_paid_packages_total_count = sessionStorage.getItem(
      "self_paid_packages_total_count"
    );
    if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
      _this.phyPersonType = "staff";
    } else {
      _this.phyPersonType = "dependents";
    }
  },
  beforeRouteEnter(to, from, next) {
    if (
      from.name == "SetMealDetails" ||
      from.name == "HospitalDetails" ||
      from.name == "PhyAckOrder"
    ) {
      // 这个name是下一级页面的路由name
      to.meta.isBack = true; // 设置为true说明你是返回到这个页面，而不是通过跳转从其他页面进入到这个页面
    }
    next();
  },
  watch: {
    "allUserMsg.contacttel": {
      handler: function () {
        if (
          JSON.parse(sessionStorage.getItem("userMsg")).contacttel ===
          this.allUserMsg.contacttel
        ) {
          this.yzm = false;
        } else {
          // console.log(7987897)
          this.yzm = true;
        }
      },
    },
  },
  async activated() {
    let _this = this;
    if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
      _this.phyPersonType = "staff";
    } else {
      _this.phyPersonType = "dependents";
    }
    if (!_this.$route.meta.isBack || _this.isFirstEnter) {
      //前进到该页面刷新当前页面重新取值
      _this.getHosDetail = JSON.parse(sessionStorage.getItem("project"));
      _this.showLimit = 0.0;
      this.number = 0;
      _this.limitMsg = [];
      _this.radio = "";
      _this.cityValue = "";
      _this.cityId = ""; //选中的城市id
      _this.hospitalValue = "";
      _this.tjTimeValue = ""; //选中的预约时间
      _this.phyDataList = [];
      _this.adcode = "";
      _this.cityDataList = [];
      _this.packageList = [];
      _this.packageCheckList = [];
      _this.additionCheckList = [];
      _this.additionList = [];
      _this.lat = "";
      _this.lng = "";
      _this.phyId = ""; //选中的套餐的id
      _this.hospitalList = [];
      _this.hosId = ""; //选中的分院的id
      _this.addressMsg = "";
      _this.isFirstEnter = false; // 定义变量来判断是否第一次进入，默认false
      _this.isAloneMsg = false;
      _this.phyPrice = "";
      _this.equityCard = 0; //选中的权益卡的id
      _this.packagesIDS = []; //选中加项包的id数组
      _this.packagesCode = []; //选中加项包的id、code数组
      _this.additionIDS = []; //选中加项的id数组
      _this.additionCode = []; //选中加项的id、code数组
      _this.timeCheck = ""; //转化过后的选中的时间
      //编辑体检人的一些字段
      _this.dialogVisible = false;
      _this.isMobile = true;
      _this.show = false;
      _this.counts = "";
      _this.timer = null;
      _this.mobileVal = "";
      _this.organValue = "";
      _this.organList = [];
      _this.brandsCode = "";
      _this.brandsSort = "";
      _this.star = "";
      _this.peoValue = "";
      _this.depId = "";
      _this.addPhysicalVisible = false;
      _this.relationRadio = "1";
      _this.isIdCard = false;
      _this.idcardType = this.$t("m.staffMsg.editDialog.chooseType");
      _this.marryRadio = "1";
      _this.closeOnClickModal = false;
      _this.sexRadio = "0";
      _this.birthDate = "";
      // _this.phyPersonType = _this.$route.query.type;
      _this.interpretVisible = false;
      _this.datajson = {};
      _this.combointerpretVisible = false;
      _this.reportVisible = false;
      _this.isAgree = 0;
      _this.max_extraexampackages = 0;
      _this.minimum_extra_packages = 0;
      _this.numVisible = false;
      _this.provinceArr = [];
      _this.cityArr = [];
      _this.countyArr = [];
      _this.areaArr = [];
      _this.peoType = "";
      _this.phyID = null;
      _this.institutionType = null;
      _this.consigneeJSON = {
        consigneeName: "",
        consigneePhone: "",
        consigneeAddress: "",
        consigneeProvince: "",
        consigneeCity: "",
        consigneeCounty: "",
        consigneeArea: "",
        consigneeProvinceName: "",
        consigneeCityName: "",
        consigneeCountyName: "",
        consigneeAreaName: "",
      };
      _this.phyGender = "";
      await _this.getCity();
      await _this.getPhysical();
      await _this.getQY();
      // _this.getBenefit();

      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
    } else {
      // let relativeId;
      // if (_this.$route.query.type == "staff") {
      //     relativeId = _this.allUserMsg.id;
      // } else {
      //     relativeId = _this.depId;
      // }
    }
    // // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    _this.$route.meta.isBack = false;
    // // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    _this.isFirstEnter = false;
  },
  filters: {
    number(value) {
      var toFixedNum = Number(value).toFixed(3);
      var realVal = toFixedNum.substring(0, toFixedNum.toString().length - 1);
      return realVal;
    },
    hideMiddle(val) {
      if (val) {
        return `${val.substring(0, 3)}****${val.substring(val.length - 3)}`;
      }
    },
    hidePhone(p) {
      if (p) {
        return p.substring(0, 3) + "*****" + p.substring(p.length - 2);
      }
    },
  },
  methods: {
    ...mapActions(["message"]),
    aaaaaaa(e, item) {
      item.checked = !item.checked;
      console.log(e);
      if (item.id == 563 && e) {
        this.ctPackage = true;
      }
    },
    //获取免费权益个数
    getQY() {
      let params = {
        pid: this.project.id,
      };
      this.fullscreenLoading = true;
      axios
        .get(BASE_URL + "/exam/mt/relatives/benefit/", {
          params: params,
        })
        .then((res2) => {
          this.fullscreenLoading = false;
          this.free_amount = res2.data.data.free_amount;
        })
        .catch((err) => {
          this.fullscreenLoading = false;
        });
    },
    //展开
    zhankai() {
      var pdom = document.getElementById("priceMsg");
      var icon = document.getElementById("openImg");
      if (this.openTxt === "展开详情>>") {
        this.openTxt = "Pick up";
        this.openTxt = "收起详情>>";
      } else {
        this.openTxt = "展开详情>>";
        icon.style.transform = "rotate(" + 360 + "deg)";
      }
      // if (this.openTxt === "展开") {
      //     this.openTxt = "收起";
      //     pdom.style.height = pdom.scrollHeight + "px";
      //     icon.style.transform = "rotate(" + 90 + "deg)";
      // } else {
      //     this.openTxt = "展开";
      //     pdom.style.height = 0;
      //     icon.style.transform = "rotate(" + 360 + "deg)";
      // }
    },
    //是否同意查看体检报告
    agreement(id) {
      console.log(id);
      this.isCreateUser = id;
    },

    //点击四级地址-省
    changeConsigneeProvince(val) {
      let _this = this;
      _this.cityArr = [];
      _this.countyArr = [];
      _this.areaArr = [];
      _this.consigneeJSON.consigneeCity = "";
      _this.consigneeJSON.consigneeCounty = "";
      _this.consigneeJSON.consigneeArea = "";
      _this.getAddress(2, val);
      _this.ConsigneeCityLoading = true;
      let obj = {};
      _this.provinceArr.find((item) => {
        item.cities.find((items) => {
          if (items.id == val) {
            obj = items;
          }
        });
      });
      _this.consigneeJSON.consigneeProvinceName = obj.name;
    },
    // 点击四级地址-市
    changeConsigneeCity(val) {
      let _this = this;
      _this.countyArr = [];
      _this.areaArr = [];
      _this.consigneeJSON.consigneeCounty = "";
      _this.consigneeJSON.consigneeArea = "";
      _this.getAddress(3, val);
      _this.ConsigneeCountyLoading = true;
      let obj = {};
      _this.cityArr.find((item) => {
        item.cities.find((items) => {
          if (items.id == val) {
            obj = items;
          }
        });
      });
      _this.consigneeJSON.consigneeCityName = obj.name;
    },
    // 点击四级地址-县
    changeConsigneeCounty(val) {
      let _this = this;
      _this.areaArr = [];
      _this.consigneeJSON.consigneeArea = "";
      _this.getAddress(4, val);
      _this.ConsigneeAreaLoading = true;
      let obj = {};
      _this.countyArr.find((item) => {
        item.cities.find((items) => {
          if (items.id == val) {
            obj = items;
          }
        });
      });
      _this.consigneeJSON.consigneeCountyName = obj.name;
    },
    // 点击四级地址-区
    changeConsigneeArea(val) {
      let _this = this;
      let obj = {};
      _this.areaArr.find((item) => {
        item.cities.find((items) => {
          if (items.id == val) {
            obj = items;
          }
        });
      });
      _this.consigneeJSON.consigneeAreaName = obj.name;
    },
    //获取四级地址的接口
    getAddress(num, id) {
      let _this = this;
      _this.fullscreenLoading = true;
      axios
        .get(BASE_URL + "/exam/cities/" + id + "/")
        .then((res) => {
          _this.fullscreenLoading = false;
          _this.ConsigneeProvinceLoading = false;
          _this.ConsigneeCityLoading = false;
          _this.ConsigneeCountyLoading = false;
          _this.ConsigneeAreaLoading = false;
          if (num === 1) {
            _this.provinceArr = res.data.data.region_list;
          } else if (num === 2) {
            _this.cityArr = res.data.data.region_list;
          } else if (num === 3) {
            _this.countyArr = res.data.data.region_list;
          } else if (num === 4) {
            _this.areaArr = res.data.data.region_list;
          }
        })
        .catch((err) => {
          _this.fullscreenLoading = false;
          _this.ConsigneeProvinceLoading = false;
          _this.ConsigneeCityLoading = false;
          _this.ConsigneeCountyLoading = false;
          _this.ConsigneeAreaLoading = false;
        });
    },
    numOk() {
      let _this = this;
      _this.numVisible = false;
      _this.reportVisible = true;
    },

    //弹窗获取套餐详情
    getMealMsg(id) {
      let _this = this;
      _this.datajson = {};
      _this.combointerpretVisible = true;
      _this.comboDetailLoading = true;
      let exam_type;
      if (_this.$route.query.type == "staff") {
        exam_type = "";
      } else {
        exam_type = "&exam_type=relative";
      }
      let params = {
        project: _this.project.id,
      };

      //获取套餐详情接口git更换名字
      axios
        .get(
          BASE_URL +
            "/exam/hospitals/" +
            _this.hosId +
            "/combos/" +
            id +
            "/" +
            "?project=" +
            _this.project.id +
            exam_type
        )
        .then((res) => {
          _this.comboDetailLoading = false;
          _this.datajson = res.data.data;
        })
        .catch((err) => {
          _this.comboDetailLoading = false;
        });
    },
    //关闭按钮
    closeBtn(type) {
      let _this = this;
      if (type == "combo") {
        _this.combointerpretVisible = false;
      } else {
        _this.interpretVisible = false;
      }
    },
    //弹窗获取分院详情
    getHosMsg() {
      let _this = this;
      _this.interpretVisible = true;
      _this.datajson = {};
      _this.hosDetailLoading = true;
      //获取详情接口
      axios
        .get(BASE_URL + "/exam/hospitals/" + _this.hosId + "/", {
          params: {
            project: _this.project.id,
          },
        })
        .then((res) => {
          _this.hosDetailLoading = false;
          _this.datajson = res.data.data;
          setTimeout(function () {
            _this.setMap();
          }, 100);
        })
        .catch((err) => {
          _this.hosDetailLoading = false;
        });
    },
    // 地图
    setMap() {
      let _this = this;
      //创建Map实例
      var map = new BMap.Map("XSDFXPage");

      // 初始化地图,设置中心点坐标
      var point = new BMap.Point(
        parseFloat(_this.datajson.longitude),
        parseFloat(_this.datajson.latitude)
      ); // 创建点坐标
      map.centerAndZoom(point, 15);

      //添加鼠标滚动缩放
      map.enableScrollWheelZoom();

      //添加缩略图控件
      map.addControl(
        new BMap.OverviewMapControl({
          isOpen: false,
          anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        })
      );
      //添加缩放平移控件
      map.addControl(new BMap.NavigationControl());
      //添加比例尺控件
      map.addControl(new BMap.ScaleControl());
      //添加地图类型控件
      //map.addControl(new BMap.MapTypeControl());

      //设置标注的图标
      var icon = new BMap.Icon(
        require("../../../assets/icon.png"),
        new BMap.Size(100, 100)
      );
      //设置标注的经纬度
      var marker = new BMap.Marker(
        new BMap.Point(
          parseFloat(_this.datajson.longitude),
          parseFloat(_this.datajson.latitude)
        ),
        {
          icon: icon,
        }
      );
      //把标注添加到地图上
      map.addOverlay(marker);
      var content = "<table>";
      // content = content + "<tr><td> 编号：001</td></tr>";
      content = content + "<tr><td> " + _this.datajson.name + "</td></tr>";
      // content = content + "<tr><td> 时间：2018-1-3</td></tr>";
      content += "</table>";
      var infowindow = new BMap.InfoWindow(content);
      marker.addEventListener("click", function () {
        _this.openInfoWindow(infowindow);
      });

      //点击地图，获取经纬度坐标
      // map.addEventListener("click",function(e){
      //      document.getElementById("aa").innerHTML = "经度坐标："+e.point.lng+" &nbsp;纬度坐标："+e.point.lat;
      //  });
    },
    //点击选择证件类型
    handleCommand(command) {
      let _this = this;
      if (command == "a") {
        _this.idcardType = _this.$t("m.common.nationalType.idcard");
        _this.isIdCard = false;
      } else if (command == "b") {
        _this.idcardType = _this.$t("m.common.nationalType.passport");
        _this.isIdCard = true;
      } else if (command == "c") {
        _this.idcardType = _this.$t("m.common.nationalType.gat");
        _this.isIdCard = true;
      } else if (command == "d") {
        _this.idcardType = _this.$t("m.common.nationalType.other");
        _this.isIdCard = true;
      }
    },
    //点击添加体检人弹窗的确定按钮
    addPhyOkBtn() {
      let _this = this;

      //校验参数
      if (_this.$refs.addPhyName.value == "") {
        let data = {
          message: _this.$t("m.person.editError.name"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (
        _this.idcardType == _this.$t("m.staffMsg.editDialog.chooseType")
      ) {
        let data = {
          message: _this.$t("m.person.editError.type"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (_this.$refs.addPhyidCard.value == "") {
        let data = {
          message: _this.$t("m.person.editError.card"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (
        _this.idcardType == _this.$t("m.common.nationalType.idcard") &&
        !cardReg.test(_this.$refs.addPhyidCard.value)
      ) {
        let data = {
          message: _this.$t("m.person.editError.okCard"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (
        _this.idcardType != _this.$t("m.common.nationalType.idcard") &&
        _this.birthDate == ""
      ) {
        let data = {
          message: _this.$t("m.person.editError.birth"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (_this.$refs.addPhyphone.value == "") {
        let data = {
          message: _this.$t("m.person.editError.phone"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (!phoneReg.test(_this.$refs.addPhyphone.value)) {
        let data = {
          message: _this.$t("m.person.editError.okPhone"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (_this.jsmarriage == null) {
        let data = {
          message: "请选择婚姻状况",
          type: "error",
          center: true,
        };
        _this.message(data);
      } else {
        //整理添加体检人需要传的参数
        let params = {
          name: _this.$refs.addPhyName.value,
          identity_code: _this.$refs.addPhyidCard.value,
          contacttel: _this.$refs.addPhyphone.value,
          marriage: _this.jsmarriage,
        };
        if (_this.idcardType == _this.$t("m.common.nationalType.idcard")) {
          params.identity_type = 0;
        } else {
          if (_this.idcardType == _this.$t("m.common.nationalType.passport")) {
            params.identity_type = 1;
          } else if (
            _this.idcardType == _this.$t("m.common.nationalType.gat")
          ) {
            params.identity_type = 2;
          } else if (
            _this.idcardType == _this.$t("m.common.nationalType.other")
          ) {
            params.identity_type = 3;
          }
          if (_this.sexRadio == "1") {
            params.gender = 1;
          } else if (_this.sexRadio == "2") {
            params.gender = 0;
          }
          params.birthday = _this.changeTime(_this.birthDate);
        }
        // console.log(params)
        _this.dialogLoading = true;
        //添加体检人接口
        axios
          .post(BASE_URL + "/exam/relatives/", params)
          .then((res) => {
            // console.log(res);
            _this.addPhysicalVisible = false;
            _this.dialogLoading = false;
            _this.getPhysical();
            let data = {
              message: _this.$t("m.person.addSuccess"),
              type: "success",
              center: true,
            };
            _this.message(data);
          })
          .catch((err) => {
            _this.dialogLoading = false;
          });
      }
    },
    //转化时间
    changeTime(time) {
      // console.log(time);
      var mytime = new Date(time);
      // console.log(mytime)
      var year = mytime.getFullYear(),
        month = ("0" + (mytime.getMonth() + 1)).slice(-2),
        date = ("0" + mytime.getDate()).slice(-2);
      var dateStr = year + "-" + month + "-" + date;
      return dateStr;
    },
    //点击显示添加体检人弹窗
    addPhyShow() {
      let _this = this;
      _this.addPhysicalVisible = true;
      _this.$refs.addPhyName.value = "";
      _this.idcardType = _this.$t("m.staffMsg.editDialog.chooseType");
      _this.relationRadio = "1";
      _this.birthDate = "";
      _this.$refs.addPhyphone.value = "";
      _this.$refs.addPhyidCard.value = "";
      _this.marryRadio = "1";
      _this.sexRadio = "0";
      _this.jsmarriage = null;
      _this.isIdCard = false;
    },
    //点击选择家属
    changeDep(val) {
      let a = this.relationship.filter((item) => item.id === val);
      this.gender_value = a[0].gender_value;
      let _this = this;
      let obj = {};
      obj = this.phyExPeoList.find((item) => {
        return item.id === val;
      });
      _this.peoType = obj.relationship;
      _this.brandsCode = "";
      _this.organList = [];
      _this.hospitalList = [];
      _this.phyDataList = [];
      _this.organValue = "";
      _this.packageList = [];
      _this.additionList = [];
      _this.hosId = "";
      _this.tjTimeValue = "";
      _this.hospitalValue = "";
      // if (_this.brandsCode != "") {
      //     _this.getHospitals(
      //         _this.brandsCode,
      //         _this.cityId,
      //         _this.lat,
      //         _this.lng
      //     );
      // }
      _this.cityDataList.area_group.forEach(function (element) {
        element.cities.forEach(function (element2) {
          if (element2.id == val) {
            return (_this.confirmMsg.cityNameCheck = element2.name);
          }
        });
      });
      _this.isCreateUser = 1;
      _this.reportType = "";
      _this.branchType = "";
      _this.brands();
      // let relativeId;
      // if (_this.$route.query.type == "staff") {
      //     relativeId = _this.allUserMsg.id;
      // } else {
      //     relativeId = _this.depId;
      // }
      // axios
      //     .get(
      //         BASE_URL +
      //         "/exam/hospitals/" +
      //         this.hospitalId +
      //         "/combos/?project=" + _this.project.id + '&relative=' +
      //         relativeId
      //     )
      //     .then((res) => {
      //         if (res.data.data.status) {
      //             if (this.hospitalValue) {
      //                 _this.getCardData();
      //             }
      //         } else {
      //             _this.$message.error(res.data.data.description);
      //             _this.peoValue = "";
      //         }
      //     });
      _this.$forceUpdate();
      _this.depId = val;
    },
    //点击选择机构分类
    changeBrands(val) {
      let _this = this;
      sessionStorage.setItem("val", val);
      _this.$forceUpdate();
      // _this.getAddress(1, 0);
      // _this.ConsigneeProvinceLoading = true;
      _this.brandsCode = val;
      _this.hosId = "";
      _this.phyId = "";
      _this.radio = "";
      _this.hospitalValue = "";
      _this.tjTimeValue = "";
      _this.hospitalList = [];
      _this.phyDataList = [];
      _this.packageList = [];
      _this.number = 0;
      _this.showLimit = 0;
      _this.additionList = [];
      _this.limitMsg = [];
      if (_this.cityId != "") {
        _this.getHospitals(
          _this.brandsCode,
          _this.cityId,
          _this.lat,
          _this.lng
        );
      }
      _this.organList.forEach(function (element) {
        if (element.id == val) {
          _this.institutionType = element.institution_type;
          _this.confirmMsg.brandsName = element.name;
          _this.brandsSort = element.institution_type;
        }
      });
      if(this.settings.cityRemind){
            let arr = this.settings.cityRemind.mechanism
            // console.log(obj)
            if(arr.length!=0){
              arr.forEach(item=>{
                if(item.cityName == _this.confirmMsg.cityNameCheck && _this.confirmMsg.brandsName.indexOf(item.mechanismName) != -1){
                    this.cityTitle = item.title
                    this.dialogVisible2 = true
                }
              })
            }
            
        }
      _this.confirmMsg.report_type = null;
      _this.confirmMsg.branch_type = null;
      _this.isCreateUser = 1;
      _this.reportType = "";
      _this.branchType = "";
    },
    //机构分类列表
    brands() {
      let _this = this;
      _this.brandLoading = true;
      axios
        .get(
          BASE_URL + "/exam/batch/" + _this.$route.query.batch + "/brands/",
          {
            params: {
              city_id: _this.cityId,
            },
          }
        )
        .then((res) => {
          _this.organList = res.data.data;
          _this.brandLoading = false;
        })
        .catch((err) => {
          _this.brandLoading = false;
        });
    },
    //修改手机号的获取验证码
    getCode() {
      let _this = this;
      let phoneReg = /^1[3456789]\d{9}$/;
      if (_this.$refs.getphone.value == "") {
        let data = {
          message: _this.$t("m.staffMsg.editDialog.errMsg.phone"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (!phoneReg.test(_this.$refs.getphone.value)) {
        let data = {
          message: _this.$t("m.staffMsg.editDialog.errMsg.okPhone"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (_this.$refs.getphone.value == _this.allUserMsg.contacttel) {
        let data = {
          message: _this.$t("m.staffMsg.editDialog.errMsg.existPhone"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else {
        axios
          .post(BASE_URL + "/user/bind/mobile/", {
            mobile: _this.$refs.getphone.value,
          })
          .then((res) => {
            let TIME_COUNT = 60;
            _this.mobileVal = _this.$refs.getphone.value;
            _this.isMobile = true;
            if (!_this.timer) {
              _this.counts = TIME_COUNT;
              _this.show = false;
              _this.timer = setInterval(() => {
                if (_this.counts > 0 && _this.counts <= TIME_COUNT) {
                  _this.counts--;
                } else {
                  _this.show = true;
                  clearInterval(_this.timer);
                  _this.timer = null;
                }
              }, 1000);
            }
          });
      }
    },
    //点击编辑信息文字
    editBtn() {
      let _this = this;
      _this.yzm = false;
      _this.code = null;
      _this.counts = 0;
      _this.dialogVisible = true;
      _this.isMobile = false;
      _this.show = true;
    },
    //选择时间
    getTime(val) {
      this.getHosTime(this.phyPersonType);
      // console.log(val)
      let _this = this;
      _this.timeCheck = val;
    },
    //选择城市
    changeCity(val) {
      if (val == 141 || val == 163) {
        this.reminder = true;
      }
      this.$alert(
          "应疫情防控要求，非当日预约将严格执行拒检。眼科、耳鼻喉、口腔、肺功能、C13/C14项目必须提供48小时内核酸检测报告（或者客户可以选择在现场更换可提供的等值项目）。体检当天必须提供辽事通绿码、体检预约短信。14天内有中高风险城市旅居史的客户不接待。给您带来的不便请谅解",
          "温馨提示",
          {
            confirmButtonText: "确定",
            callback: (action) => {},
          }
        );
      let _this = this;
      _this.$forceUpdate();
      _this.cityId = val;
      _this.brandsCode = "";
      _this.organList = [];
      _this.hospitalList = [];
      _this.phyDataList = [];
      _this.organValue = "";
      _this.packageList = [];
      _this.additionList = [];
      _this.hosId = "";
      _this.tjTimeValue = "";
      _this.hospitalValue = "";
      if (_this.brandsCode != "") {
        _this.getHospitals(
          _this.brandsCode,
          _this.cityId,
          _this.lat,
          _this.lng
        );
      }
      _this.cityDataList.area_group.forEach(function (element) {
        element.cities.forEach(function (element2) {
          if (element2.id == val) {
            return (_this.confirmMsg.cityNameCheck = element2.name);
          }
        });
      });
      if(this.settings.cityRemind){
          let arr = this.settings.cityRemind.city
        // console.log(obj)
        if(arr.length!=0){
          arr.forEach(item=>{
            if(item.cityName == _this.confirmMsg.cityNameCheck){
              this.cityTitle = item.title
              this.dialogVisible2 = true
            }
          })
        }
        
      }
      _this.isCreateUser = 1;
      _this.reportType = "";
      _this.branchType = "";
      _this.brands();
    },
    //选择加项包
    changePackage(val) {
      let _this = this;
      let packages = [],
        packageNameCheck = [],
        newVal,
        max_extraexampackages;
      _this.packagesIDS = val;
      //数据层次太多，没有触发render函数进行自动更新，需手动调用
      // _this.$forceUpdate();
      _this.packagesCode = [];
      _this.packageList.forEach(function (element, index) {
        element.disabled = false;
      });
      val.forEach(function (element, index) {
        _this.packageList.forEach(function (element2, index2) {
          if (element == element2.id) {
            element2.disabled = false;
            let obj = {
              package_id: element2.id,
              code: element2.local_package_code,
            };
            _this.packagesCode.push(obj);
            // packages.push(element2.sell_price);
            packageNameCheck.push(element2.name);
          } else {
            element2.disabled = true;
          }
        });
      });
      _this.confirmMsg.packageNameCheck = packageNameCheck;
      // _this.getAddition()
      _this.limit();
    },
    //实时计算额度的变化
    limit() {
      let _this = this;
      let relativeId;
      if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
        relativeId = _this.allUserMsg.id;
      } else {
        relativeId = _this.depId;
      }
      _this.showLimit = 0.0;
      let params = {
        hospital: _this.hosId,
        project: _this.project.id,
        relative: relativeId,
        combo: _this.phyId,
      };

      if (_this.phyId != "") {
        params.combo = _this.phyId;
      }

      if (_this.phyPersonType == "staff") {
        params.relative = _this.allUserMsg.id;
      } else {
        params.relative = _this.depId;
      }

      if (_this.packagesCode.length != 0) {
        params.extra_packages = _this.packagesCode;
      }

      if (_this.additionCode.length != 0) {
        params.self_paid_packages = _this.additionCode;
      }
      _this.fullscreenLoading = true;
      //实时计算价格接口
      axios
        .post(BASE_URL + "/exam/realtime/price/", params)
        .then((res) => {
          _this.limitMsg = res.data.data;
          _this.fullscreenLoading = false;
          _this.showLimit = res.data.data.total_price;
          _this.number =
            res.data.data.payment_detail.extra_packages.length +
            res.data.data.payment_detail.self_paid_packages.length;
        })
        .catch((err) => {
          _this.fullscreenLoading = false;
        });
    },
    //change自费加项
    changeAddition(val) {
      console.log(val);
      let _this = this;
      // console.log(val==563)
      console.log(val);
      let additionNameMsgCheck = [];
      _this.additionIDS = val;
      _this.additionCode = [];
      _this.getHosTime(_this.phyPersonType);
      val.forEach(function (element, index) {
        _this.additionList.forEach(function (element2, index2) {
          if (element == element2.id) {
            let obj = {
              package_id: element2.id,
              code: element2.local_package_code,
            };

            _this.additionCode.push(obj);
            additionNameMsgCheck.push(element2.name);
          } else {
            element2.checked = false;
          }
        });
      });
      _this.confirmMsg.additionNameMsgCheck = additionNameMsgCheck;
      _this.limit();
    },
    //获取分院可约时间列表
    getHosTime(type) {
      let _this = this;
      let params = {
        combo: _this.phyId,
        project: _this.project.id,
        self_paid: _this.additionCheckList.join(',')
      };
      timeData = [];
      _this.timeLoading = true;
      // 获取分院可约时间接口
      axios
        .get(
          BASE_URL + "/exam/hospitals/" + parseInt(_this.hosId) + "/schedule/",
          {
            params: params,
          }
        )
        .then((res) => {
          _this.timeLoading = false;
          let data = res.data.data;
          data.forEach(function (element) {
            if (element.maxNum > element.usedNum) {
              timeData.push(element.regDate);
            }
          });
          _this.pickerOptions = {
            disabledDate(time) {
              var year = time.getFullYear(),
                month = ("0" + (time.getMonth() + 1)).slice(-2),
                date = ("0" + time.getDate()).slice(-2);
              var dateStr = year + "-" + month + "-" + date;
              return timeData.indexOf(dateStr) == -1;
            },
          };
        })
        .catch((err) => {
          _this.timeLoading = false;
        });
    },
    //选择分院
    changeHos(selVal) {
      let _this = this;
      _this.$forceUpdate();
      _this.radio = "";
      _this.packageCheckList = [];
      _this.packagesCode = [];
      _this.packagesIDS = [];
      _this.showLimit = 0;
      _this.phyDataList = [];
      _this.packageList = [];
      _this.additionList = [];
      _this.limitMsg = [];
      _this.phyId = [];
      _this.number = 0;
      _this.hosId = selVal;
      _this.hospitalList.forEach(function (element) {
        if (element.id == _this.hosId) {
          _this.reportType = element.report_type;
          _this.branchType = element.branch_type;
          _this.addressMsg = element.address;
          _this.confirmMsg.hosNameCheck = element.name;
          _this.confirmMsg.report_type = element.report_type;
          _this.confirmMsg.branch_type = element.branch_type;
          _this.star = Number(element.star);
        }
      });
      if(this.settings.cityRemind){
            let arr = this.settings.cityRemind.branch
            // console.log(obj)
            if(arr.length != 0){
              arr.forEach(item=>{
                if(item.cityName == _this.confirmMsg.cityNameCheck && _this.confirmMsg.brandsName.indexOf(item.mechanismName) != -1 && _this.confirmMsg.hosNameCheck.indexOf(item.branchName) != -1){
                    this.cityTitle = item.title
                    this.dialogVisible2 = true
                }
              })
            }
            
        }
      _this.confirmMsg.addressMsg = _this.addressMsg;
      _this.tjTimeValue = "";
      // _this.getHosTime(_this.phyPersonType);
      // _this.getCardData();
      //获取是否有体检报告
      axios
        .get(BASE_URL + "/exam/abb/reports/comment/", {
          params: {
            branch_id: selVal,
          },
        })
        .then((res) => {
          _this.isShowReport = res.data.data;
        });
      _this.getPhyList();
    },
    //选择套餐点击单选
    changePhy(val) {
      let _this = this;
      let strVal = parseInt(val.split("_"));
      _this.phyId = strVal;
      _this.phyID = strVal;
      _this.packagesCode = [];
      _this.additionCheckList = [];
      _this.packageCheckList = [];
      let phy, equityCard, phyNameCheck;
      _this.phyDataList.forEach(function (element) {
        if (element.id == strVal) {
          // phy = element.sell_price;
          phyNameCheck = element.name;
          sessionStorage.setItem("comboMarital", element.marital);
        }
      });
      _this.phyPrice = phy;
      _this.equityCard = equityCard;
      _this.confirmMsg.phyNameCheck = phyNameCheck;
      setTimeout(() => {
        _this.getAddition();
        _this.getPackage();
        _this.getHosTime(_this.phyPersonType);
      });
      _this.limit();
      // console.log(_this.)
      // _this.additionList.forEach(function(element2, index2) {
      //     _this.self_paid_packages.forEach(function(ele) {
      //         console.log(element2, ele)
      //         if (element2 === ele.package_id) {
      //             let obj = {
      //                 package_id: element2.id,
      //                 code: element2.local_package_code,
      //             };
      //             _this.additionCode.push(obj);
      //             additionNameMsgCheck.push(element2.name);
      //         }
      //     })
      // });
    },
    //获取分院列表
    getHospitals(brand_code, city, latitude, longitude) {
      let _this = this;
      _this.hospitalLoading = true;
      // _this.hospitalValue = '';
      // let params = {
      // 	brand:brand_code,
      // 	city:city,
      // 	latitude:latitude==''?0.00:latitude,
      // 	longitude:longitude==''?0.00:longitude
      // }
      let relativeId;
      if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
        relativeId = _this.allUserMsg.id;
      } else {
        relativeId = _this.depId;
      }
      //获取分院接口
      axios
        .get(
          BASE_URL + "/exam/batch/" + _this.$route.query.batch + "/branches/",
          {
            params: {
              city_id: city,
              brand_id: brand_code,
              project: JSON.parse(sessionStorage.getItem("project")).id,
              relative: relativeId,
              group_name: _this.$route.query.group_name,
            },
          }
        )
        .then((res) => {
          _this.hospitalList = res.data.data;
          _this.hospitalLoading = false;
        })
        .catch((err) => {
          _this.hospitalLoading = false;
        });
    },
    //获取城市列表
    getCity() {
      let _this = this;
      _this.cityLoading = true;
      //获取城市列表接口
      axios
        .get(BASE_URL + "/exam/batch/" + _this.$route.query.batch + "/cities/")
        .then((res) => {
          _this.cityLoading = false;
          _this.cityDataList = res.data.data;
          _this.getCurrentCity();
        })
        .catch((err) => {
          _this.cityLoading = false;
        });
    },

    //获取加项包列表
    getPackage() {
      let _this = this;
      let id;
      if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
        id = _this.allUserMsg.id;
      } else {
        id = _this.depId;
      }
      _this.packagesLoading = true;
      //获取加项包列表接口
      axios
        .get(
          BASE_URL +
            "/exam/hospitals/" +
            _this.hosId +
            "/extra/packages/?project=" +
            _this.project.id +
            "&relative=" +
            id
        )
        .then((res) => {
          _this.packagesLoading = false;
          _this.packageList = res.data.data.packages;
        })
        .catch((err) => {
          _this.packagesLoading = false;
        });
    },
    //获取加项列表
    getAddition() {
      let _this = this;
      let id;
      if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
        id = _this.allUserMsg.id;
      } else {
        id = _this.depId;
      }
      let staff_info = JSON.parse(sessionStorage.getItem("staff_info"));
      _this.additionLoading = true;
      //获取加项列表接口
      axios
        .get(
          BASE_URL +
            "/exam/hospitals/" +
            _this.hosId +
            "/self/paid/extra/packages/?project=" +
            _this.project.id +
            "&relative=" +
            id +
            "&combo=" +
            _this.phyId
        )
        .then((res) => {
          _this.additionLoading = false;
          // res.data.data.packages.forEach((e,a)=>{
          //     item.flag = false
          // })
          var arr = [];
          _this.additionList = res.data.data.packages;
          if (
            _this.$route.query.type != "dependents" &&
            _this.self_paid_packages_total_count != 0
          ) {
            res.data.data.packages.forEach((ele, index) => {
              staff_info.self_paid_packages.forEach((ele1, inx) => {
                if (ele.id == ele1.package_id) {
                  ele.flag = true;
                  arr.push(ele1.package_id);
                }
              });
            });

            _this.additionCheckList = arr.map((a) => a * 1);
            _this.changeAddition(_this.additionCheckList);
          }
        })
        .catch((err) => {
          _this.additionLoading = false;
        });
    },
    //加项包详情
    packageDetail(name, clinic_mean) {
      let _this = this;
      _this.$alert(clinic_mean, name, {
        confirmButtonText: _this.$t("m.common.define"),
        callback: (action) => {},
      });
    },
    finalSubmit() {
      let _this = this;
      let params = {},
        paramsJSON = {};
      if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
        paramsJSON.relative = _this.allUserMsg.id;
      } else {
        paramsJSON.relative = _this.depId;
      }
      paramsJSON.report_authorize = _this.isAgree; //授权报告是否同意
      paramsJSON.project = _this.project.id; //项目id
      paramsJSON.combo = _this.phyId; //套餐id
      paramsJSON.card_no = _this.$route.query.cardNo; //权益卡id
      paramsJSON.hospital = _this.hosId; //分院id
      if (_this.packagesIDS.length != 0) {
        paramsJSON.add_packages = _this.packagesIDS; //加项包的id数组
      }
      if (_this.additionIDS.length != 0) {
        paramsJSON.self_paid_packages = _this.additionIDS; //加项的id数组
      }
      paramsJSON.exam_date = _this.timeCheck; //预约日期
      // if (_this.brandsSort == 1) {
      //   paramsJSON.receiver_address = {
      //     name: _this.consigneeJSON.consigneeName,
      //     mobile: _this.consigneeJSON.consigneePhone,
      //     region_id:
      //       _this.consigneeJSON.consigneeProvince +
      //       "_" +
      //       _this.consigneeJSON.consigneeCity +
      //       "_" +
      //       _this.consigneeJSON.consigneeCounty +
      //       "_" +
      //       _this.consigneeJSON.consigneeArea,
      //     region_name:
      //       _this.consigneeJSON.consigneeProvinceName +
      //       "_" +
      //       _this.consigneeJSON.consigneeCityName +
      //       "_" +
      //       _this.consigneeJSON.consigneeCountyName +
      //       "_" +
      //       _this.consigneeJSON.consigneeAreaName,
      //     detail_address: _this.consigneeJSON.consigneeAddress,
      //     full_address:
      //       _this.consigneeJSON.consigneeProvinceName +
      //       _this.consigneeJSON.consigneeCityName +
      //       _this.consigneeJSON.consigneeCountyName +
      //       _this.consigneeJSON.consigneeAreaName +
      //       _this.consigneeJSON.consigneeAddress
      //   };
      // }

      // paramsJSON.pay_success_url = successPage_URL+'';//成功页面url
      params.paramsJSON = paramsJSON;
      params.confirmMsg = _this.confirmMsg;
      params.confirmMsg.limit = _this.showLimit; //剩余额度
      params.confirmMsg.star = _this.star; //分院评分
      params.confirmMsg.organValue = _this.organValue; //机构分类
      params.confirmMsg.max_extraexampackages = _this.max_extraexampackages; //多少个免费加项
      params.limitMsg = _this.limitMsg;
      //confirmMsg订单确认页面仅展示的信息
      //paramsJSON订单确认页面提交预约传入接口的参数
      sessionStorage.setItem("staffParams", JSON.stringify(params));

      sessionStorage.setItem("type", _this.$route.query.type);
      sessionStorage.setItem("authorization", _this.isCreateUser);
      sessionStorage.setItem("institutionType", _this.institutionType);

      _this.$router.push({
        path: "/phyAckOrder",
        query: {
          type: _this.$route.query.type,
          isShowReport: _this.isShowReport,
          // cardId: _this.$route.query.cardId,
          // authorization: _this.isCreateUser,
          // institutionType: _this.institutionType
        },
      });
    },
    //提交订单
    submit() {
      let _this = this;
      let institution_type;
      _this.organList.forEach(function (element) {
        if (element.id === _this.organValue) {
          institution_type = element.institution_type;
        }
      });
      let phoneReg = /^1[3456789]\d{9}$/;
      if (!_this.cityId) {
        let data = {
          message: _this.$t("m.staffMsg.cityPlaceholder"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (!_this.brandsCode) {
        let data = {
          message: _this.$t("m.staffMsg.brands"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (!_this.hosId) {
        let data = {
          message: _this.$t("m.staffMsg.hospital"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (!_this.tjTimeValue) {
        let data = {
          message: _this.$t("m.staffMsg.time"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (!_this.phyId) {
        let data = {
          message: _this.$t("m.staffMsg.chooseMeal"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else if (_this.$route.query.type == "dependents" && !_this.depId) {
        let data = {
          message: _this.$t("m.dependentsMsg.changeDep"),
          type: "error",
          center: true,
        };
        _this.message(data);
      } else {
        if (_this.packagesIDS.length != 1 && _this.packageList.length != 0) {
          _this.$message.error("请选择腰椎或者颈椎检查");
          //判断是否是公立医院，公立医院不需要判断加项包
          // _this.numVisible = true;
        } else {
          _this.finalSubmit();
        }
      }
    },
    //获取体检人权益（有多少免费加项包）
    getBenefit() {
      let _this = this;
      let card_type;
      if (location.href.split("?")[1].split("&")[0].split("=")[1] != "staff") {
        card_type = "&card_type=relative";
      } else {
        card_type = "";
      }
      axios
        .get(
          BASE_URL +
            "/exam/relatives/benefit/?project=" +
            _this.project.id +
            card_type
        )
        .then((res) => {
          //有多少免费加项包
          _this.max_extraexampackages = res.data.data.max_extraexampackages;
          //至少选择多少个加项包
          _this.minimum_extra_packages = res.data.data.minimum_extra_packages;
        });
    },
    //小米项目获取体检卡套餐、定制加项、自费加项
    getCardData() {
      this.comboLoading = true;
      this.additionLoading = true;
      this.packagesLoading = true;
      let depId = this.depId;
      let params = {
        language: 0,
        brand_id: this.brandsCode,
        branch_id: this.hosId,
        city_id: this.cityId,
        report_authority: 0,
      };
      if (this.$route.query.type === "staff") {
        params.exam_user_id = this.allUserMsg.id;
        params.relation = this.allUserMsg.relationship;
        params.gender = this.allUserMsg.gender;
        params.marriage = this.allUserMsg.marriage;
        params.birthday = this.allUserMsg.birthday
          ? this.allUserMsg.birthday
          : "1990-01-01";
      } else {
        params.exam_user_id = depId;

        this.phyExPeoList.forEach(function (element) {
          if (element.id === depId) {
            params.relation = element.relationship;
            params.gender = element.gender;
            params.marriage = element.marriage;
            params.birthday = element.birthday;
          }
        });
      }
      let relativeId;
      let _this = this;
      if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
        relativeId = _this.allUserMsg.id;
      } else {
        relativeId = _this.depId;
      }
      let group_name = _this.$route.query.group_name;
      axios
        .get(BASE_URL + "/exam/hospitals/" + _this.hosId + "/combos/", {
          params: {
            project: this.project.id,
            relative: relativeId,
            group_name,
          },
        })
        .then((res) => {
          this.comboLoading = false;
          this.additionLoading = false;
          this.packagesLoading = false;
          this.phyDataList = res.data.data;
          this.phyGender = res.data.data[0].gender;
          this.additionList = res.data.data.self_paid_combos;
          this.packageList = res.data.data.extra_combos;
          this.additionIDS = [];
          this.additionCode = [];
          let additionNameMsgCheck = [];
          let self_paid_combos = res.data.data.self_paid_combos;
          let num = 0;
          self_paid_combos.map((element) => {
            if (element.use_rights) {
              num++;
              let obj = {
                package_id: element.id,
                code: element.local_package_code,
              };
              this.additionIDS.push(element.id);
              this.additionCode.push(obj);
              additionNameMsgCheck.push(element.name);
            }
          });
          this.dhNum = num;
          this.confirmMsg.additionNameMsgCheck = additionNameMsgCheck;
          //只有一个套餐时默认选中
          if (res.data.data.combos.length == 1) {
            this.radio = res.data.data.combos[0].id + "_";
            this.phyId = res.data.data.combos[0].id;
            this.confirmMsg.phyNameCheck = res.data.data.combos[0].name;
            this.limit();
          }

          let arr = [];
          self_paid_combos.forEach(function (element) {
            arr.push(element.id);
          });
          params.self_paid_pack_list = arr.toString();
          axios
            .post(BASE_URL + "/exam/self/paid/packages/recommend/", params)
            .then((res1) => {
              // this.additionLoading = false;
              self_paid_combos.forEach(function (element) {
                res1.data.data.forEach(function (element1) {
                  if (element.id === element1.package_id) {
                    element.isRecommend = true;
                  }
                });
              });
              this.additionList = self_paid_combos;
              this.$forceUpdate();
            })
            .catch((err1) => {});
        })
        .catch((err) => {
          this.comboLoading = false;
          this.additionLoading = false;
          this.packagesLoading = false;
        });
    },
    //点击编辑员工信息弹框的确定
    editOkBtn() {
      if (
        JSON.parse(sessionStorage.getItem("userMsg")).contacttel !=
        this.allUserMsg.contacttel
      ) {
        if (this.code == null && this.yzm == true) {
          let data = {
            message: "请输入验证码",
            type: "error",
            center: true,
          };
          this.message(data);
        }
      }
      if (
        this.allUserMsg.contacttel == "" ||
        this.allUserMsg.contacttel == undefined
      ) {
        this.$message({
          message: "请填写手机号",
          type: "error",
          center: true,
        });
      } else {
        axios
          .post(BASE_URL + `/exam/relatives/update/mobile/`, {
            mobile: this.allUserMsg.contacttel,
            token: this.code,
            marriage: this.allUserMsg.marriage,
            project: JSON.parse(sessionStorage.getItem("project")).id,
          })
          .then((res) => {
            if (res.data.return_code == 0) {
              this.$message.success("修改成功");
              this.dialogVisible = false;
              axios
                .get(BASE_URL + "/exam/relatives/")
                .then((res1) => {
                  this.fullscreenLoading = false;
                  res1.data.data.forEach(function (element) {
                    sessionStorage.setItem("userMsg", JSON.stringify(element));
                  });
                })
                .catch((err) => {
                  _this.fullscreenLoading = false;
                });
            }
          });
      }
    },
    // 获取验证码
    getCode() {
      if (!this.allUserMsg.contacttel) {
        this.$message({
          message: "请填写手机号",
          type: "error",
          center: true,
        });
      } else if (!phoneReg.test(this.allUserMsg.contacttel)) {
        this.$message({
          message: "请填写正确的手机号",
          type: "error",
          center: true,
        });
      } else {
        let _this = this;
        axios
          .post(BASE_URL + `/exam/relatives/update/token/`, {
            mobile: this.allUserMsg.contacttel,
            project: JSON.parse(sessionStorage.getItem("project")).id,
          })
          .then((res) => {
            let TIME_COUNT = 60;
            if (!_this.timer) {
              _this.counts = TIME_COUNT;
              _this.phomeCodeShow = false;
              _this.timer = setInterval(() => {
                if (_this.counts > 0 && _this.counts <= TIME_COUNT) {
                  _this.counts--;
                } else {
                  _this.phomeCodeShow = true;
                  clearInterval(_this.timer);
                  _this.timer = null;
                }
              }, 1000);
            }
          });
      }
    },
    //获取套餐列表
    getPhyList() {
      let _this = this;
      let id;
      let group_name = _this.$route.query.group_name;
      if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
        id = _this.allUserMsg.id;
      } else {
        id = _this.depId;
      }
      axios
        .get(`${BASE_URL}/exam/hospitals/${_this.hosId}/combos/`, {
          params: {
            project: _this.project.id,
            relative: id,
            group_name,
          },
        })
        .then((res) => {
          _this.comboLoading = false;
          _this.phyDataList = res.data.data;

          //   if (res.data.data.length == 1) {
          //     _this.radio = res.data.data[0].id + "_";
          //     _this.phyId = res.data.data[0].id;
          //     _this.confirmMsg.phyNameCheck = res.data.data[0].name;
          //     _this.limit();
          //   }
        })
        .catch((err) => {
          _this.comboLoading = false;
        });

      // if (location.href.split("?")[1].split("&")[0].split("=")[1] == "dependents") {
      //     id = _this.depId;
      //     group_name = _this.$route.query.group_name;
      //     axios
      //         .get(`${BASE_URL}/exam/hospitals/${_this.hosId}/combos/`, {
      //             params: {
      //                 project: _this.project.id,
      //                 relative: id,
      //                 group_name,
      //             },
      //         })
      //         .then((res) => {
      //             _this.comboLoading = false;
      //             _this.phyDataList = res.data.data;

      //         })
      //         .catch((err) => {
      //             _this.comboLoading = false;
      //         });
      // }
      // _this.comboLoading = true;

      //获取套餐列表接口
      // axios
      //     .get(`${BASE_URL}/exam/hospitals/${_this.hosId}/combos/`, {
      //         params: {
      //             project: _this.project.id,
      //             relative: id,
      //             group_name,
      //         },
      //     })
      //     .then((res) => {
      //         _this.comboLoading = false;
      //         _this.phyDataList = res.data.data;

      //         //   if (res.data.data.length == 1) {
      //         //     _this.radio = res.data.data[0].id + "_";
      //         //     _this.phyId = res.data.data[0].id;
      //         //     _this.confirmMsg.phyNameCheck = res.data.data[0].name;
      //         //     _this.limit();
      //         //   }
      //     })
      //     .catch((err) => {
      //         _this.comboLoading = false;
      //     });
    },
    //定位
    getCurrentCity() {
      let _this = this;
      let p = new Promise(function (resolve, reject) {
        getCurrentCityName().then((res) => {
          _this.cityDataList.area_group.forEach(function (element) {
            element.cities.forEach(function (element2) {
              if (element2.name == res.name) {
                _this.cityValue = element2.name;
                _this.cityId = element2.id;
                _this.lat = res.center.lat;
                _this.lng = res.center.lng;
                _this.confirmMsg.cityNameCheck = _this.cityValue;
                _this.brands();
              }
            });
          });
          _this.getAdcode();
        });
      });
    },
    //获取城市code
    getAdcode() {
      let _this = this;
      var map = new AMap.Map("container", {
        resizeEnable: true,
      });
      var adcode = map.getAdcode();
      _this.adcode = adcode;
    },
    //获取体检人列表
    getPhysical() {
      let _this = this;
      _this.peopleLoading = true;
      axios
        .get(BASE_URL + "/exam/relatives/")
        .then((res) => {
          _this.peopleLoading = false;
          _this.phyExPeoList = res.data.data;
          _this.phyExPeoList.forEach(function (element) {
            if (element.relationship == 0) {
              _this.allUserMsg = element;
            }
          });
        })
        .catch((err) => {
          _this.peopleLoading = false;
        });
    },
  },
  mounted() {
    let _this = this;
    if (location.href.split("?")[1].split("&")[0].split("=")[1] == "staff") {
      _this.phyPersonType = "staff";
    } else {
      _this.phyPersonType = "dependents";
    }
  },
  computed: {
    ...mapGetters(["currentUser"]), // 动态计算属性，相当于this.$store.getters.resturantName
    //避免v-for和v-if放在一个标签上，在这里过滤（体检人列表过滤掉员工本人展示）
    relationship() {
      return this.phyExPeoList.filter(function (item) {
        return item.relationship != 0;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.hint {
  display: flex;
  margin-left: 70px;
  margin-bottom: 10px;
  margin-top: -19px;
}

.per {
  margin-left: 26px;
  margin-top: 10px;
}

.per p:first-child {
  font-size: 14px;
  font-weight: 400;
  color: #ff000f;
  line-height: 20px;
}

.per p:last-child {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 20px;
  /* margin-top: 10px; */
}

.zhu {
  margin-left: 270px;
  margin-top: 20px;
}

.zhu p {
  font-size: 18px;
  font-weight: normal;
  color: #ff000f;
  line-height: 18px;
}

.details {
  width: 100%;
  margin: 0 auto;
}

.details .tit {
  width: 100%;
  height: 46px;
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  background: #fdeee8;
  margin-top: 30px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.details .tit p {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 16px;
}

.mealName {
  width: 100%;
  height: 78px;
  border: 1px solid #ccc;
  margin: 0 auto;
  /*margin-top: 30px;*/
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 30px;
}

.mealName .icon {
  width: 4px;
  height: 18px;
  background: #ff000f;
}

.mealName .name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 18px;
  margin-left: 7px;
}

.mealName .msg {
  font-size: 14px;
  font-weight: 400;
  color: #ff000f;
  line-height: 16px;
  margin-left: 10px;
}

.mapMsg {
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
}

.mapMsg p span:first-child {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  line-height: 26px;
}

.mapMsg p span:last-child {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  line-height: 26px;
}

.map {
  width: 100%;
  height: 260px;
  border: 1px solid #ccc;
  margin: 0 auto;
  margin-top: 30px;
  padding: 20px;
}

.map img {
  width: 100%;
  height: 100%;
}

.hospitalName {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.hospitalName .icon {
  width: 4px;
  height: 18px;
  background: #ff000f;
}

.hospitalName .name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 18px;
  margin-left: 7px;
}

.borderBottom {
  border-bottom: none !important;
}

.active {
  color: #333 !important;
}

.womanNote {
  margin-left: 290px;
  font-size: 16px;
  font-weight: 400;
  color: #666;
  line-height: 16px;
  margin-top: 10px;
}

.gratis {
  text-decoration: line-through;
}

.nogratis {
  text-decoration: none;
}

.note {
  font-size: 18px;
  font-weight: normal;
  color: #ff000f;
  line-height: 18px;
}

.getcode {
  width: 92px;
  height: 30px;
  background: #999999;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  line-height: 16px;
  margin-right: 10px;
  cursor: pointer;
}

.editMsg {
  width: 100%;
}

.editMsg .item {
  width: 100%;
  height: 50px;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.editMsg .item p:first-child {
  width: 120px;
  text-align: center;
  /*padding: 17px 20px;*/
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
}

.editMsg .item p:last-child {
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid #dfdfdf;
  padding-left: 20px;
}

.editMsg .item input {
  width: 60%;
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid #dfdfdf;
  padding-left: 20px;
}

.editMsg .item .radioDiv {
  width: 60%;
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid #dfdfdf;
  padding-left: 20px;
}

.zfMsg {
  border-top: 2px solid #eaeaea;
  margin-top: 30px;
}

.zfMsg .right .addition {
  width: 760px;
  border: 1px solid #eaeaea;
  margin-top: 30px;
  padding-bottom: 15px;
  /*margin-left: 20px;*/
  /*padding-right: 20px;*/
}

.zfMsg .right .addition .msg {
  width: 100%;
  /* padding: 20px 20px 0 20px; */
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
}

.zfMsg .right .addition .msg .price {
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
}

.zfMsg .right .addition .msg .msgLeft {
  display: flex;
  align-items: center;
}

.zfMsg .right .addition .msg .msgLeft p {
  font-size: 14px;
  font-weight: 400;
  color: #ff000f;
  line-height: 14px;
  margin-left: 10px;
  text-decoration: underline;
  cursor: pointer;
}

.zfMsg .right .addition .additionItem {
  width: 100%;
  border-bottom: 2px solid #eaeaea;
  padding: 15px 15px 15px 20px;
}

.zfMsg .right .addition .additionItem p {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 14px;
  margin-top: 15px;
  margin-left: 26px;
}

.projectMsg {
  display: flex;
}

.projectMsg .tit {
  width: 120px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
}

.projectMsg div {
  display: flex;
  flex-direction: column;
}

.projectMsg div p {
  margin-bottom: 10px !important;
}

.integral {
  width: 1180px;
  height: 46px;
  background: rgba(242, 242, 242, 1);
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;
  padding-left: 22px;
  position: relative;
  align-items: center;
}

.integral .left p {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 14px;
}

.integral .right {
  display: flex;
  align-items: center;
}

.integral .right .jxNum {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 14px;
}

.integral .right .jxNum span {
  color: #e51e26;
}

.integral .right .price {
  font-size: 14px;
  font-weight: 400;
  position: absolute;
  right: 200px;
  color: #666;
  line-height: 14px;
  margin-left: 30px;
}

.integral .right .price span {
  color: #ff000f;
  font-size: 16px;
  font-weight: bold;
  line-height: 16px;
}

.integral .right .submit {
  width: 180px;
  height: 46px;
  background: #ff000f;
  display: flex;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  margin-left: 50px;
  font-size: 20px;
  /*font-weight:600;*/
  color: #fff;
  line-height: 20px;
  cursor: pointer;
}

.additionalItemPackage {
  /* border-top: none !important; */
  margin-top: 30px !important;
}

.additionalItemPackage .msg .right .packageItem {
  padding: 15px 15px 15px 20px;
}

.additionalItemPackage .msg .right .packageItem:last-child {
  border-bottom: 1px solid #eaeaea !important;
}

.additionalItemPackage .msg .right .packageItem .name {
  display: flex;
  justify-content: space-between;
}

.additionalItemPackage .msg .right .packageItem .name p {
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
}

.additionalItemPackage .msg .right .packageItem .msgItem {
  display: flex;
  margin-top: 10px;
  margin-left: 26px;
}

.additionalItemPackage .msg .right .packageItem .msgItem p:first-child {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 14px;
}

.additionalItemPackage .msg .right .packageItem .msgItem img {
  margin-left: 5px;
  cursor: pointer;
  width: 16px;
  height: 16px;
}
/*.additionalItemPackage .msg .right .packageItem .msgItem p:last-child{
		font-size:12px;

		font-weight:400;
		color:#FF000F;
		line-height:12px;
		text-decoration: underline;
		margin-left: 20px;
		cursor: pointer;
	}*/

.additionalItemPackage .zfMsg .right .packageItem .msgItem p:last-child {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 14px;
  text-decoration: none;
  margin-left: 0;
}

.additionalItemPackage .zfMsg .right .packageItem .name div span {
  font-size: 12px;
  font-weight: 400;
  color: #ff000f;
  line-height: 12px;
  text-decoration: underline;
  cursor: pointer;
}

.breadNav {
  width: 100%;
  height: 80px;
  border-bottom: 2px solid #eaeaea;
  display: flex;
  align-items: center;
}

.breadNav p {
  width: 1180px;
  margin: 0 auto;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 20px;
}

.tjUser {
  width: 1180px;
  /*padding: 30px;*/
  display: flex;
  align-items: center;
  margin: 0 auto;
  border: 1px solid #cccccc;
  margin-top: 30px;
  padding: 30px;
}

.tjUser2 {
  width: 1180px;
  /*padding: 30px;*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  border: 1px solid #cccccc;
  margin-top: 30px;
  padding: 30px;
  .name2 {
    display: flex;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    .icon2 {
      width: 4px;
      height: 18px;
      background: #ff000f;
      margin-right: 8px;
      line-height: 22px;
    }
  }
  .hint2 {
    font-size: 16px;
    margin-top: 15px;
    display: flex;
    p {
      line-height: 26px;
    }
  }
}

.tjUser .icon,
.tjHos .tit .icon,
.tjSetMeal .tit .icon,
.additionalItemPackage .tit .icon {
  width: 4px;
  height: 18px;
  background: #ff000f;
}

.tjSetMeal .icon {
  width: 4px;
  height: 18px;
  float: left;
  margin-right: 8px;
  background: #ff000f;
}

.tjUser .name,
.tjHos .tit .name,
.tjSetMeal .tit .name,
.additionalItemPackage .tit .name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-left: 7px;
  line-height: 18px;
}

.tjUser .edit {
  font-size: 14px;
  font-weight: 400;
  color: #ff000f;
  line-height: 16px;
  text-decoration: underline;
  margin-top: 4px;
  margin-left: 10px;
  cursor: pointer;
}

.tjSetMeal {
  padding: 30px 30px 0 30px !important;
}

.additionalItemPackage {
  padding: 0 30px 30px 30px !important;
}

.additionalItemPackage .msg .left {
  margin-top: 16px !important;
}

.additionalItemPackage .msg .right {
  margin-top: 0 !important;
}

.tjHos,
.tjSetMeal,
.additionalItemPackage {
  width: 1180px;
  margin: 0 auto;
  border: 1px solid #cccccc;
  margin-top: 30px;
  padding: 30px;
}

.tjHos .tit,
.tjSetMeal .tit,
.additionalItemPackage .tit {
  display: flex;
  align-items: center;
}

.tjHos .hospital {
  margin-top: 44px;
  display: flex;
  align-items: center;
}

.tjHos .hospital p,
.tjHos .time p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 18px;
  width: 220px;
  text-align: right;
  margin-left: 30px;
}

.tjHos .hospital .city {
  width: 170px;
  margin-left: 20px;
}

.tjHos .hospital .hosName {
  width: 370px;
  margin-left: 20px;
}

.tjHos .hosDetail {
  margin: 0px 0 16px 286px;
  display: flex;
}

.tjHos .hosDetail p:first-child {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  line-height: 16px;
}

.tjHos .hosDetail p:last-child {
  font-size: 12px;
  font-weight: 400;
  color: #ff000f;
  line-height: 16px;
  text-decoration: underline;
  margin-left: 20px;
  cursor: pointer;
}

.tjHos .time {
  display: flex;
  align-items: center;
  margin-top: 30px;
}

.tjHos .time .chooseTime {
  width: 560px;
  margin-left: 20px;
}

.tjSetMeal .tit .tsTest,
.additionalItemPackage .tit .tsTest {
  font-size: 18px;
  font-weight: 600;
  color: #ff000f;
  line-height: 18px;
}

.tjSetMeal .msg,
.additionalItemPackage .msg {
  display: flex;
}

.tjSetMeal .msg .left,
.additionalItemPackage .msg .left {
  width: 220px;
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 18px;
  text-align: right;
  margin-top: 48px;
  margin-left: 30px;
}

.additionalItemPackage .msg .right .el-checkbox-group {
  width: 760px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  margin-left: 20px;
  /*width: 50%;*/
}

.additionalItemPackage .msg .right .packageItem {
  min-width: 50%;
  max-width: 50%;
  /*flex: 1;*/
  border: 1px solid #eaeaea;
}

.tjSetMeal .msg .right {
  width: 760px;
  border: 1px solid #eaeaea;
  /*margin-top: 30px;*/
  margin-left: 20px;
}

.tjSetMeal .msg .right .tcName {
  width: 100%;
  height: 46px;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-right: 30px;
  justify-content: space-between;
}

.tjSetMeal .msg .right .tcName .tcPrice p {
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
}

.tjSetMeal .msg .right .tcName:last-child {
  border-bottom: none;
}

.tjSetMeal .msg .right .tcName span {
  font-size: 14px;
  font-weight: 400;
  color: #ff000f;
  line-height: 16px;
  text-decoration: underline;
  display: inline-block;
  margin-top: 3px;
  cursor: pointer;
}

.borderTop {
  border-top: none !important;
}

.left1 {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 18px;
  float: left;
  width: 220px;
  text-align: right;
  margin-left: 23px;
  margin-top: 14px;
}

.tcName1 {
  width: 100%;
  height: 46px;
  border-bottom: 1px solid #eaeaea;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 20px;
  padding-right: 30px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 10px 0;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #ff000f !important;
}

.el-radio__input.is-checked .el-radio__inner {
  background: #ff000f !important;
  border-color: #ff000f !important;
}

.integralMsg {
  width: 1180px;
  margin: 0 auto;
  padding-bottom: 7px;
  background: #f8f8f8;
  margin-top: 20px;
  border-radius: 20px 20px 0px 0px;
}

.combo {
  padding: 22px 30px 0 30px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.combo p {
  font-size: 14px;
  font-weight: 400;
  font-weight: bold;
  color: #666666;
  line-height: 14px;
}

h3 {
  font-size: 14px;
  font-weight: 600;
  color: #046bde;
  line-height: 14px;
  margin-bottom: 15px;
  padding: 0 30px 0 30px;
}

.list {
  padding: 0 30px 0 30px;
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 14px;
      margin-bottom: 15px;
    }
    p:last-child {
      color: black;
    }
  }
}

.name1 {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-left: 7px;
  width: 1180px;
  line-height: 18px;
}

.reportTit {
  width: 1180px;
  margin: 0 auto;
  border: 1px solid #ccc;
  margin-top: 30px;
  padding-left: 30px;
}

.reportTit div {
  display: flex;
  width: 1180px;
  margin: 30px 0 12px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.reportTit .icon {
  width: 4px;
  height: 18px;
  background: #ff000f;
}

.reportTit .name {
  font-size: 16px;
  margin-left: 10px;
  font-weight: 600;
  color: #333;
  line-height: 18px;
}

.reportTit .xq {
  margin-left: 13px;
  font-size: 18px;
  font-weight: 400;
  color: #ff000f;
  line-height: 30px;
}

.reportTit .xq:nth-child(3) {
  margin-bottom: 25px;
}

.syrq {
  margin-top: 21px;
  margin-left: 20px;
}

.syrq div img {
  width: 22px;
  height: 22px;
  position: relative;
  z-index: 999;
}

.syrq div span {
  width: 68px;
  height: 20px;
  background: #ffeeef;
  display: inline-block;
  color: #ff000f;
  font-size: 15px;
  text-align: center;
  line-height: 20px;
  margin-left: -5px;
}

.syrq > div > p {
  padding: 0 10px 0 5px;
  color: #666666;
  line-height: 20px;
  margin-top: 11px;
  font-weight: 400;
}

.jctype {
  padding: 5px 20px;
  background: #f8f8f8;
  margin-top: 15px;
}

.djs {
  width: 20%;
  height: 50px;
  position: absolute;
  bottom: 123px;
  text-align: center;
  background: #ff000f;
  line-height: 50px;
  border-radius: 5px;
  color: #fff;
  right: 35px;
}

.djs1 {
  width: 20%;
  height: 50px;
  position: absolute;
  bottom: 123px;
  text-align: center;
  background: #c5c5c5;
  line-height: 50px;
  border-radius: 5px;
  color: #fff;
  right: 35px;
}

.ts {
  padding-bottom: 20px;
  padding-left: 105px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}

.tcts {
  color: #ff000f;
  margin-left: 294px;
  padding-top: 10px;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/selfPhyExService/writeSubscribe.vue